/* eslint-disable */
/* tslint:disable */
/* biome-ignore */
/**
* ⚠️ AUTO-GENERATED FILE
* This file was generated by GraphQL Code Generator.
* Do not edit this file directly.
*
* Auto-generation runs automatically when:
* 1. You commit changes to schema.graphql (via pre-commit hook)
* 2. You run 'yarn codegen' manually
*
* To trigger manual generation:
* - yarn codegen (generates schema types) OR make schema_dump (dumps latest schema from dev db and generates types)
*/

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * Represents non-fractional signed whole numeric values. Since the value may
   * exceed the size of a 32-bit integer, it's encoded as a string.
   */
  BigInt: { input: any; output: any; }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: any; output: any; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: any; output: any; }
  /** Represents untyped JSON */
  JSON: { input: any; output: any; }
};

/** Represents the response of aborting an ongoing data ingestion event */
export type AbortEvent = {
  __typename?: 'AbortEvent';
  /** Message indicating the result of the abort operation */
  message: Scalars['String']['output'];
};

/** Autogenerated return type of AddToWatchListMutation. */
export type AddToWatchListMutationPayload = {
  __typename?: 'AddToWatchListMutationPayload';
  errors: Array<Scalars['String']['output']>;
  watchList?: Maybe<WatchList>;
};

export type Analytics = {
  __typename?: 'Analytics';
  analytics: Scalars['JSON']['output'];
  maxY?: Maybe<Scalars['BigInt']['output']>;
  metaData?: Maybe<Scalars['JSON']['output']>;
};

export type Asset = {
  __typename?: 'Asset';
  acreage?: Maybe<Scalars['Float']['output']>;
  activeWellCount?: Maybe<Scalars['Int']['output']>;
  api?: Maybe<Scalars['Float']['output']>;
  assetModels?: Maybe<Array<Asset>>;
  assetNpvs?: Maybe<Array<AssetNpv>>;
  assetViewPictureUrl?: Maybe<Scalars['String']['output']>;
  baseName?: Maybe<Scalars['String']['output']>;
  basin?: Maybe<Basin>;
  basinId?: Maybe<Scalars['String']['output']>;
  boundingBox?: Maybe<Scalars['JSON']['output']>;
  breakevenOil: Scalars['String']['output'];
  cachedMapData: Scalars['JSON']['output'];
  companyId: Scalars['String']['output'];
  country: Country;
  countryId: Scalars['ID']['output'];
  countryViewPictureUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currentDate?: Maybe<Scalars['ISO8601Date']['output']>;
  currentEmissionsIntensity?: Maybe<Scalars['Float']['output']>;
  currentParticipations?: Maybe<Array<Participation>>;
  developmentStatus?: Maybe<DevelopmentStatus>;
  developmentType?: Maybe<DevelopmentType>;
  developmentWellCount?: Maybe<Scalars['Int']['output']>;
  discoveryDate?: Maybe<Scalars['ISO8601Date']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  enhancedPdfReport?: Maybe<Scalars['String']['output']>;
  enhancedReport?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  estimatedCurrentDate?: Maybe<Scalars['ISO8601Date']['output']>;
  estimatedRecentProduction?: Maybe<Scalars['Float']['output']>;
  estimatedRecentProductionGasMmcfd?: Maybe<Scalars['Float']['output']>;
  estimatedRecentProductionLiquidsBbld?: Maybe<Scalars['Float']['output']>;
  expectedProjectSanction?: Maybe<Scalars['Int']['output']>;
  firstProductionDate?: Maybe<Scalars['ISO8601Date']['output']>;
  fiscalRegime?: Maybe<Scalars['String']['output']>;
  formattedAcreage?: Maybe<Scalars['String']['output']>;
  formattedApi?: Maybe<Scalars['String']['output']>;
  formattedCurYrTotalProdIntensityKgco2ePerBoe?: Maybe<Scalars['String']['output']>;
  formattedEstimatedRecentProdGasMmcfd?: Maybe<Scalars['String']['output']>;
  formattedEstimatedRecentProdLiqBbld?: Maybe<Scalars['String']['output']>;
  formattedGasEurBcf?: Maybe<Scalars['String']['output']>;
  formattedGasIpMmcfd?: Maybe<Scalars['String']['output']>;
  formattedHydrocarbonType?: Maybe<Scalars['String']['output']>;
  formattedLiquidsEurMmbbl?: Maybe<Scalars['String']['output']>;
  formattedLiquidsIpBbld?: Maybe<Scalars['String']['output']>;
  formattedNpv?: Maybe<Scalars['String']['output']>;
  formattedNpvBoe?: Maybe<Scalars['String']['output']>;
  formattedOpexBoe?: Maybe<Scalars['String']['output']>;
  formattedPeakProductionBoed?: Maybe<Scalars['String']['output']>;
  formattedRecentProdGasMmcfd?: Maybe<Scalars['String']['output']>;
  formattedRecentProdLiquidsBbld?: Maybe<Scalars['String']['output']>;
  formattedRemainingCapex?: Maybe<Scalars['String']['output']>;
  formattedRemainingReserves?: Maybe<Scalars['String']['output']>;
  formattedReservoirDepth?: Maybe<Scalars['String']['output']>;
  formattedReservoirDepthM?: Maybe<Scalars['String']['output']>;
  formattedVerticalDepth?: Maybe<Scalars['String']['output']>;
  formattedVerticalDepthM?: Maybe<Scalars['String']['output']>;
  formattedWaterDepth?: Maybe<Scalars['String']['output']>;
  formattedWaterDepthM?: Maybe<Scalars['String']['output']>;
  formattedWeaProdGasMmcfd?: Maybe<Scalars['String']['output']>;
  formattedWeaProdLiquidsBbld?: Maybe<Scalars['String']['output']>;
  formattedXFactor?: Maybe<Scalars['String']['output']>;
  gasEurBcf?: Maybe<Scalars['Float']['output']>;
  gasIpMmcfd?: Maybe<Scalars['Float']['output']>;
  geologies?: Maybe<Array<Geology>>;
  geom?: Maybe<Scalars['JSON']['output']>;
  hydrocarbonType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  isHpht?: Maybe<Scalars['Boolean']['output']>;
  lastTwelveMonthsAverageProdBoed?: Maybe<Scalars['Float']['output']>;
  legacyId?: Maybe<Scalars['ID']['output']>;
  licenseAwardDate?: Maybe<Scalars['ISO8601Date']['output']>;
  licenseExpirationDate?: Maybe<Scalars['ISO8601Date']['output']>;
  licensingRound?: Maybe<Scalars['String']['output']>;
  liquidsEurMmbbl?: Maybe<Scalars['Float']['output']>;
  liquidsIpBbld?: Maybe<Scalars['Float']['output']>;
  mAndAOpportunity?: Maybe<Scalars['Boolean']['output']>;
  maOpportunities?: Maybe<Array<MaOpportunity>>;
  name: Scalars['String']['output'];
  npv?: Maybe<Scalars['Float']['output']>;
  npvBoe?: Maybe<Scalars['Float']['output']>;
  opexBoe?: Maybe<Scalars['Float']['output']>;
  origin?: Maybe<Scalars['Int']['output']>;
  originalGasInPlaceBcf?: Maybe<Scalars['Float']['output']>;
  originalOilInPlaceMmbbl?: Maybe<Scalars['Float']['output']>;
  participations?: Maybe<Array<Participation>>;
  pdfReport?: Maybe<Scalars['String']['output']>;
  peakProductionBoe?: Maybe<Scalars['Float']['output']>;
  peakProductionDate?: Maybe<Scalars['ISO8601Date']['output']>;
  pipelineNetwork?: Maybe<Scalars['String']['output']>;
  pipelineNetworkSegment?: Maybe<Scalars['String']['output']>;
  pipelineNetworks?: Maybe<Array<PipelineNetwork>>;
  pricePerBarrel?: Maybe<Scalars['Float']['output']>;
  recentProdGasMmcfd?: Maybe<Scalars['Float']['output']>;
  recentProdLiquidsBbld?: Maybe<Scalars['Float']['output']>;
  relatedExplorations?: Maybe<RelatedExplorations>;
  remainingCapex?: Maybe<Scalars['Float']['output']>;
  remainingEmissionsIntensity?: Maybe<Scalars['Float']['output']>;
  remainingReserves?: Maybe<Scalars['Float']['output']>;
  report?: Maybe<Scalars['String']['output']>;
  reportUpdatedDate?: Maybe<Scalars['ISO8601Date']['output']>;
  reserve?: Maybe<Reserve>;
  reservoirDepthM?: Maybe<Scalars['Float']['output']>;
  resourceType?: Maybe<ResourceType>;
  searchKeys?: Maybe<Scalars['String']['output']>;
  sectionGeomCoordinates?: Maybe<Array<Scalars['JSON']['output']>>;
  shoreStatus?: Maybe<ShoreStatus>;
  similarAssets?: Maybe<Scalars['JSON']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  totalEaWells?: Maybe<Scalars['Int']['output']>;
  totalInjectionWells?: Maybe<Scalars['Int']['output']>;
  totalOtherWells?: Maybe<Scalars['Int']['output']>;
  totalProductionWells?: Maybe<Scalars['Int']['output']>;
  totalRemainingWells?: Maybe<Scalars['Int']['output']>;
  totalWellsDrilled?: Maybe<Scalars['Int']['output']>;
  transportationMethod?: Maybe<Scalars['String']['output']>;
  truckingDestination?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  typeCurveEur?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  uuid: Scalars['ID']['output'];
  verticalDepthM?: Maybe<Scalars['Float']['output']>;
  waterDepthM?: Maybe<Scalars['Float']['output']>;
  weaRecoveryFactor?: Maybe<Scalars['Float']['output']>;
  xFactor?: Maybe<Scalars['Float']['output']>;
};

export enum AssetAggregateByEnum {
  Asset = 'asset',
  CashflowYear = 'cashflowYear',
  Company = 'company',
  Country = 'country',
  Npv10 = 'npv10',
  ProductionMonth = 'productionMonth',
  WellCountYear = 'wellCountYear'
}

export type AssetAggregates = {
  __typename?: 'AssetAggregates';
  capexSum?: Maybe<Scalars['Float']['output']>;
  condensateProductionsSum?: Maybe<Scalars['Float']['output']>;
  freeCashflowSum?: Maybe<Scalars['Float']['output']>;
  gasProductionsBoedSum?: Maybe<Scalars['Float']['output']>;
  gasProductionsSum?: Maybe<Scalars['Float']['output']>;
  group: Scalars['String']['output'];
  npv0Sum?: Maybe<Scalars['Float']['output']>;
  npv5Sum?: Maybe<Scalars['Float']['output']>;
  npv10Sum?: Maybe<Scalars['Float']['output']>;
  npv15Sum?: Maybe<Scalars['Float']['output']>;
  npv20Sum?: Maybe<Scalars['Float']['output']>;
  oilProductionsSum?: Maybe<Scalars['Float']['output']>;
  pdpCondensateReservesSum?: Maybe<Scalars['Float']['output']>;
  pdpGasReservesMmboeSum?: Maybe<Scalars['Float']['output']>;
  pdpGasReservesSum?: Maybe<Scalars['Float']['output']>;
  pdpLiquidReservesSum?: Maybe<Scalars['Float']['output']>;
  pdpOilReservesSum?: Maybe<Scalars['Float']['output']>;
  remainingCapexAbexSum?: Maybe<Scalars['Float']['output']>;
  remainingConsortiumSum?: Maybe<Scalars['Float']['output']>;
  remainingEmissionsIntensitySum?: Maybe<Scalars['Float']['output']>;
  remainingEmissionsSum?: Maybe<Scalars['Float']['output']>;
  remainingGovernmentRevenueSum?: Maybe<Scalars['Float']['output']>;
  remainingOpexSum?: Maybe<Scalars['Float']['output']>;
  totalGasReservesSum?: Maybe<Scalars['Float']['output']>;
  totalLiquidReservesSum?: Maybe<Scalars['Float']['output']>;
  totalProductionsSum?: Maybe<Scalars['Float']['output']>;
  totalReservesSum?: Maybe<Scalars['Float']['output']>;
  type: AssetAggregateByEnum;
  udCondensateReservesSum?: Maybe<Scalars['Float']['output']>;
  udGasReservesMmboeSum?: Maybe<Scalars['Float']['output']>;
  udGasReservesSum?: Maybe<Scalars['Float']['output']>;
  udLiquidReservesSum?: Maybe<Scalars['Float']['output']>;
  udOilReservesSum?: Maybe<Scalars['Float']['output']>;
  values?: Maybe<Scalars['JSON']['output']>;
};

export enum AssetAggregatesFieldsEnum {
  CapexSum = 'capexSum',
  CondensateProductionsSum = 'condensateProductionsSum',
  FreeCashflowSum = 'freeCashflowSum',
  GasProductionsBoedSum = 'gasProductionsBoedSum',
  GasProductionsSum = 'gasProductionsSum',
  Npv0Sum = 'npv0Sum',
  Npv5Sum = 'npv5Sum',
  Npv10Sum = 'npv10Sum',
  Npv15Sum = 'npv15Sum',
  Npv20Sum = 'npv20Sum',
  OilProductionsSum = 'oilProductionsSum',
  PdpCondensateReservesSum = 'pdpCondensateReservesSum',
  PdpGasReservesMmboeSum = 'pdpGasReservesMmboeSum',
  PdpGasReservesSum = 'pdpGasReservesSum',
  PdpLiquidReservesSum = 'pdpLiquidReservesSum',
  PdpOilReservesSum = 'pdpOilReservesSum',
  RemainingCapexAbexSum = 'remainingCapexAbexSum',
  RemainingConsortiumSum = 'remainingConsortiumSum',
  RemainingEmissionsIntensitySum = 'remainingEmissionsIntensitySum',
  RemainingEmissionsSum = 'remainingEmissionsSum',
  RemainingGovernmentRevenueSum = 'remainingGovernmentRevenueSum',
  RemainingOpexSum = 'remainingOpexSum',
  TotalGasReservesSum = 'totalGasReservesSum',
  TotalLiquidReservesSum = 'totalLiquidReservesSum',
  TotalProductionsSum = 'totalProductionsSum',
  TotalReservesSum = 'totalReservesSum',
  UdCondensateReservesSum = 'udCondensateReservesSum',
  UdGasReservesMmboeSum = 'udGasReservesMmboeSum',
  UdGasReservesSum = 'udGasReservesSum',
  UdLiquidReservesSum = 'udLiquidReservesSum',
  UdOilReservesSum = 'udOilReservesSum',
  WellCountSum = 'wellCountSum'
}

export type AssetAggregatesInput = {
  by: AssetAggregateByEnum;
  fields: Array<AssetAggregatesFieldsEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<AssetAggregatesFieldsEnum>;
  portfolio?: InputMaybe<Portfolio>;
  stackBy?: InputMaybe<AssetStackByEnum>;
};

export type AssetAggregatesStacked = {
  __typename?: 'AssetAggregatesStacked';
  data: Array<AssetAggregates>;
  stacks: Array<Scalars['String']['output']>;
};

export type AssetNpv = {
  __typename?: 'AssetNpv';
  asset: Asset;
  formattedPercent: Scalars['String']['output'];
  formattedValue: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  npvPercent: Scalars['Float']['output'];
  npvValue: Scalars['Float']['output'];
};

export type AssetProductionTable = {
  __typename?: 'AssetProductionTable';
  condensateProductionsSum?: Maybe<Scalars['Float']['output']>;
  /** Gas monetization percentage */
  gasMonetizationPercentage?: Maybe<Scalars['Float']['output']>;
  /** Gas to oil ratio in scf/bbl */
  gasOilRatio?: Maybe<Scalars['Float']['output']>;
  /** Sales gas production in MMcf/d (what's left to sell) */
  gasProductionsSum?: Maybe<Scalars['Float']['output']>;
  /** Year-over-year growth rate in percentage */
  growthRate?: Maybe<Scalars['Float']['output']>;
  /** Total oil + condensate production in bbl/d */
  liquidsProductionsSum?: Maybe<Scalars['Float']['output']>;
  /** Oil only production in bbl/d (without condensate) */
  oilProductionsSum?: Maybe<Scalars['Float']['output']>;
  pdpCondensateProductionsSum?: Maybe<Scalars['Float']['output']>;
  pdpGasProductionsSum?: Maybe<Scalars['Float']['output']>;
  pdpOilProductionsSum?: Maybe<Scalars['Float']['output']>;
  /** Sales gas production in boe/d */
  salesGasBoeSum?: Maybe<Scalars['Float']['output']>;
  salesGasProductionsSum?: Maybe<Scalars['Float']['output']>;
  /** Total production in boe/d */
  totalProductionsSum?: Maybe<Scalars['Float']['output']>;
  udCondensateProductionsSum?: Maybe<Scalars['Float']['output']>;
  udGasProductionsSum?: Maybe<Scalars['Float']['output']>;
  udOilProductionsSum?: Maybe<Scalars['Float']['output']>;
  /** Wellhead gas production in MMcf/d (what wells actually produce) */
  wellheadGasProductionsSum?: Maybe<Scalars['Float']['output']>;
  /** Year of production data */
  year: Scalars['Int']['output'];
};

/** Input for asset production table query */
export type AssetProductionTableInput = {
  /** Portfolio filters for assets */
  portfolio: Portfolio;
};

export type AssetQuery = {
  __typename?: 'AssetQuery';
  assets: Array<Asset>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum AssetStackByEnum {
  Company = 'company',
  Country = 'country',
  DevelopmentStatus = 'developmentStatus',
  Npv10 = 'npv10',
  ProductionType = 'productionType',
  ShoreStatus = 'shoreStatus',
  WellClassification = 'wellClassification'
}

/** The connection type for Asset. */
export type AssetsConnection = {
  __typename?: 'AssetsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AssetsEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Asset>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AssetsEdge = {
  __typename?: 'AssetsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Asset>;
};

export type Authenticatable = {
  __typename?: 'Authenticatable';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type AvailableDownloads = {
  __typename?: 'AvailableDownloads';
  titles: Array<Scalars['String']['output']>;
};

export type AvailableModelDownload = {
  __typename?: 'AvailableModelDownload';
  hasDownload: Scalars['Boolean']['output'];
};

export type Basin = {
  __typename?: 'Basin';
  createdAt: Scalars['ISO8601DateTime']['output'];
  geom?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type BasinQuery = {
  __typename?: 'BasinQuery';
  basins: Array<Basin>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type Block = {
  __typename?: 'Block';
  acreage?: Maybe<Scalars['Float']['output']>;
  basin?: Maybe<Basin>;
  blockStatus?: Maybe<BlockStatus>;
  commitedWellsDrilled?: Maybe<Scalars['Int']['output']>;
  country: Country;
  createdAt: Scalars['ISO8601DateTime']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  fiscalRegime?: Maybe<FiscalRegime>;
  formattedAcreage?: Maybe<Scalars['String']['output']>;
  formattedGovernmentProfitSharePct?: Maybe<Scalars['String']['output']>;
  formattedReservoirDepth?: Maybe<Scalars['String']['output']>;
  formattedReservoirDepthM?: Maybe<Scalars['String']['output']>;
  formattedRoyaltyRatePct?: Maybe<Scalars['String']['output']>;
  formattedSignatureBonus?: Maybe<Scalars['String']['output']>;
  formattedVerticalDepth?: Maybe<Scalars['String']['output']>;
  formattedVerticalDepthM?: Maybe<Scalars['String']['output']>;
  formattedWaterDepth?: Maybe<Scalars['String']['output']>;
  formattedWaterDepthM?: Maybe<Scalars['String']['output']>;
  formattedXFactor?: Maybe<Scalars['String']['output']>;
  geom?: Maybe<Scalars['JSON']['output']>;
  governmentProfitSharePct?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  leaseLegacyId?: Maybe<Scalars['ID']['output']>;
  legacyId: Scalars['ID']['output'];
  licenseAwardDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  licenseExpirationDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  licenseStatus?: Maybe<Scalars['String']['output']>;
  licensingRound?: Maybe<LicensingRound>;
  name: Scalars['String']['output'];
  participations?: Maybe<Array<Participation>>;
  relatedExplorations?: Maybe<RelatedExplorations>;
  reservoirDepthM?: Maybe<Scalars['Float']['output']>;
  royaltyRatePct?: Maybe<Scalars['Float']['output']>;
  shoreStatus?: Maybe<ShoreStatus>;
  signatureBonus?: Maybe<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  verticalDepthM?: Maybe<Scalars['Float']['output']>;
  waterDepthM?: Maybe<Scalars['Float']['output']>;
  wellCommitmentCount?: Maybe<Scalars['Int']['output']>;
  xFactor?: Maybe<Scalars['Float']['output']>;
};

export type BlockStatus = {
  __typename?: 'BlockStatus';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type CashflowTemplate = {
  __typename?: 'CashflowTemplate';
  country?: Maybe<Country>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdBy: User;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isPublished: Scalars['Boolean']['output'];
  modelType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  publishedBy?: Maybe<User>;
  s3Bucket: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type CashflowTemplatesInput = {
  modelType?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type CashflowTemplatesQuery = {
  __typename?: 'CashflowTemplatesQuery';
  templates: Array<CashflowTemplate>;
  totalCount: Scalars['Int']['output'];
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  chatSession: ChatSession;
  childrenMessages?: Maybe<Array<ChatMessage>>;
  content: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  entities?: Maybe<Array<ChatMessageEntity>>;
  id: Scalars['ID']['output'];
  parentMessage?: Maybe<ChatMessage>;
  role: ChatMessageRoleEnum;
  status: ChatMessageStatusEnum;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ChatMessageEntity = {
  __typename?: 'ChatMessageEntity';
  chatMessage: ChatMessage;
  createdAt: Scalars['ISO8601DateTime']['output'];
  entityId: Scalars['ID']['output'];
  entityType: EntityTypeEnum;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum ChatMessageRoleEnum {
  /** Role for assistant */
  Assistant = 'ASSISTANT',
  /** Role for system */
  System = 'SYSTEM',
  /** Role for user */
  User = 'USER'
}

export enum ChatMessageStatusEnum {
  /** Chat message status for failed */
  Failed = 'FAILED',
  /** Chat message status for pending */
  Pending = 'PENDING',
  /** Chat message status for processing */
  Processing = 'PROCESSING',
  /** Chat message status for read */
  Read = 'READ',
  /** Chat message status for received */
  Received = 'RECEIVED',
  /** Chat message status for sent */
  Sent = 'SENT'
}

export type ChatSession = {
  __typename?: 'ChatSession';
  createdAt: Scalars['ISO8601DateTime']['output'];
  displayTitle: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
};

export type ChatSessionsQuery = {
  __typename?: 'ChatSessionsQuery';
  /** The list of chat sessions */
  chatSessions: Array<ChatSession>;
  /** The total count of chat sessions */
  totalCount: Scalars['Int']['output'];
};

export type Client = {
  __typename?: 'Client';
  companyTitle?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
};

export type Company = {
  __typename?: 'Company';
  createdAt: Scalars['ISO8601DateTime']['output'];
  historicalNames?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type CompanyQuery = {
  __typename?: 'CompanyQuery';
  companies: Array<Company>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ConsolidatedAssetCashflow = {
  __typename?: 'ConsolidatedAssetCashflow';
  presignedWebsocketUrl?: Maybe<Scalars['String']['output']>;
  requestId?: Maybe<Scalars['String']['output']>;
};

export type ConsolidatedAssetCashflowsRequestStatus = {
  __typename?: 'ConsolidatedAssetCashflowsRequestStatus';
  countries?: Maybe<Array<Scalars['String']['output']>>;
  email?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  presignedUrl?: Maybe<Scalars['String']['output']>;
};

/** A template for consolidated asset cashflows */
export type ConsolidatedAssetCashflowsTemplate = {
  __typename?: 'ConsolidatedAssetCashflowsTemplate';
  countryAreaIsoCodes?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ConsolidatedAssetCashflowsUserReports = {
  __typename?: 'ConsolidatedAssetCashflowsUserReports';
  presignedUrl: Scalars['ID']['output'];
  time: Scalars['ISO8601Date']['output'];
};

export type ConsolidatedAssets = {
  __typename?: 'ConsolidatedAssets';
  assetCountries?: Maybe<Scalars['JSON']['output']>;
  assetIds?: Maybe<Array<Array<Scalars['ID']['output']>>>;
};

export type Country = {
  __typename?: 'Country';
  countryStatistics?: Maybe<CountryStatistics>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  customRegion?: Maybe<Scalars['Boolean']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  geom?: Maybe<Scalars['JSON']['output']>;
  haveLiquidsReserves: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isoCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  region?: Maybe<Region>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  zoom: Scalars['Int']['output'];
};

/** Represents an event related to a country in the data ingestion tool */
export type CountryEvent = {
  __typename?: 'CountryEvent';
  /** ISO code of the country related to the event */
  countryIsoCode: Scalars['String']['output'];
  /** Progress of file normalization for the event */
  fileNormalizationProgress?: Maybe<Scalars['Float']['output']>;
  /** Unique identifier for the event */
  id: Scalars['ID']['output'];
  /** Progress of data ingestion for the event */
  ingestionProgress?: Maybe<Scalars['Float']['output']>;
  /** Message associated with the event */
  message?: Maybe<Scalars['String']['output']>;
  /** Results of the event, if applicable */
  results?: Maybe<Results>;
  /** Source configuration details associated with the event */
  source?: Maybe<Source>;
  /** Source files associated with the event */
  sourceFiles?: Maybe<Array<SourceFile>>;
  /** Identifier for the source type related to the event */
  sourceTypeId?: Maybe<Scalars['ID']['output']>;
  /** Current status of the event */
  status: Scalars['String']['output'];
  /** Timestamp when the event was created */
  timestamp: Scalars['ISO8601DateTime']['output'];
  /** Timestamp when the event was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Username of the user who created the event */
  username?: Maybe<Scalars['String']['output']>;
};

export type CountryStatistics = {
  __typename?: 'CountryStatistics';
  countOfActiveCompanies: Scalars['Int']['output'];
  countOfActiveOperators: Scalars['Int']['output'];
  countOfAssets: Scalars['Int']['output'];
  countryId: Scalars['ID']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  fiscalRegimes?: Maybe<Array<FiscalRegime>>;
  formattedAcreage?: Maybe<Scalars['String']['output']>;
  formattedTotalRemainingCapexMmusd?: Maybe<Scalars['String']['output']>;
  formattedTotalRemainingReserves?: Maybe<Scalars['String']['output']>;
  formattedTotalValuationMmusd?: Maybe<Scalars['String']['output']>;
  formattedWeaProdGasMmcfd?: Maybe<Scalars['String']['output']>;
  formattedWeaProdLiquidsBbld?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  recentGasProductionMmcfd?: Maybe<Scalars['Float']['output']>;
  recentLiquidsProductionBbld?: Maybe<Scalars['Float']['output']>;
  recentProductionDate?: Maybe<Scalars['ISO8601Date']['output']>;
  remainingReservesGasBcf?: Maybe<Scalars['Float']['output']>;
  remainingReservesLiquidsMmbbl?: Maybe<Scalars['Float']['output']>;
  reportUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  totalRemainingCapexMmusd?: Maybe<Scalars['Float']['output']>;
  totalValuationMmusd?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Input for creating a cashflow template */
export type CreateCashflowTemplateInput = {
  /** ID of the country this template is for */
  countryId?: InputMaybe<Scalars['ID']['input']>;
  /** Description of the template */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Type of model this template is for */
  modelType: Scalars['String']['input'];
  /** Name of the template */
  name?: InputMaybe<Scalars['String']['input']>;
  /** S3 bucket of the template */
  s3Bucket: Scalars['String']['input'];
  /** S3 key of the template */
  s3Key: Scalars['String']['input'];
  /** Specifies if this template is for UK and Norway or for the rest of the world */
  templateType: Scalars['String']['input'];
  /** UUID of the template */
  uuid: Scalars['String']['input'];
};

/** Autogenerated return type of CreateCashflowTemplateMutation. */
export type CreateCashflowTemplateMutationPayload = {
  __typename?: 'CreateCashflowTemplateMutationPayload';
  errors: Array<Scalars['String']['output']>;
  templates?: Maybe<Array<CashflowTemplate>>;
};

/** Autogenerated return type of CreateCompanyMutation. */
export type CreateCompanyMutationPayload = {
  __typename?: 'CreateCompanyMutationPayload';
  company?: Maybe<NexusCompany>;
};

/** Represents the response of creating a new event in the data ingestion tool */
export type CreateEvent = {
  __typename?: 'CreateEvent';
  /** ID of the newly created event */
  eventId: Scalars['ID']['output'];
  /** Presigned URLs for uploading files, where each key is the tag of a source file and the value is the corresponding URL */
  presignedUrls: Scalars['JSON']['output'];
};

/** Autogenerated return type of CreateGisFileMutation. */
export type CreateGisFileMutationPayload = {
  __typename?: 'CreateGisFileMutationPayload';
  errors: Array<Scalars['String']['output']>;
  gisFile?: Maybe<GisFile>;
};

/** Autogenerated return type of CreateGisFileUploadUrlMutation. */
export type CreateGisFileUploadUrlMutationPayload = {
  __typename?: 'CreateGisFileUploadUrlMutationPayload';
  errors: Array<Scalars['String']['output']>;
  s3Bucket?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
  signedUrl?: Maybe<SignedUrl>;
  uuid?: Maybe<Scalars['ID']['output']>;
};

export type CreateHubspotTicket = {
  __typename?: 'CreateHubspotTicket';
  created?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated return type of CreateHubspotTicketMutation. */
export type CreateHubspotTicketMutationPayload = {
  __typename?: 'CreateHubspotTicketMutationPayload';
  createHubspotTicket: CreateHubspotTicket;
};

/** Autogenerated return type of CreateManualEntityNameMappingMutation. */
export type CreateManualEntityNameMappingMutationPayload = {
  __typename?: 'CreateManualEntityNameMappingMutationPayload';
  manualEntityNameMapping?: Maybe<ManualEntityNameMapping>;
};

/** Autogenerated return type of CreatePresignedS3UrlMutation. */
export type CreatePresignedS3UrlMutationPayload = {
  __typename?: 'CreatePresignedS3UrlMutationPayload';
  errors: Array<Scalars['String']['output']>;
  s3Bucket?: Maybe<Scalars['String']['output']>;
  s3Key?: Maybe<Scalars['String']['output']>;
  signedUrl?: Maybe<SignedUrl>;
  uuid?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of CreateUserFilterMutation. */
export type CreateUserFilterMutationPayload = {
  __typename?: 'CreateUserFilterMutationPayload';
  errors: Array<Scalars['String']['output']>;
  userFilter?: Maybe<UserFilter>;
};

/** Autogenerated return type of CreateUserPortfolioFilterMutation. */
export type CreateUserPortfolioFilterMutationPayload = {
  __typename?: 'CreateUserPortfolioFilterMutationPayload';
  errors: Array<Scalars['String']['output']>;
  userPortfolioFilter?: Maybe<UserPortfolioFilter>;
};

/** Autogenerated return type of CreateUserPortfolioMutation. */
export type CreateUserPortfolioMutationPayload = {
  __typename?: 'CreateUserPortfolioMutationPayload';
  errors: Array<Scalars['String']['output']>;
  userPortfolio?: Maybe<UserPortfolio>;
};

/** Autogenerated return type of CreateUserPriceDeckMutation. */
export type CreateUserPriceDeckMutationPayload = {
  __typename?: 'CreateUserPriceDeckMutationPayload';
  errors: Array<Scalars['String']['output']>;
  userPriceDeck?: Maybe<UserPriceDeck>;
};

export type Credential = {
  __typename?: 'Credential';
  accessToken: Scalars['String']['output'];
  client: Scalars['String']['output'];
  expiry: Scalars['Int']['output'];
  tokenType: Scalars['String']['output'];
  uid: Scalars['String']['output'];
};

export type CurrentUserProfile = {
  __typename?: 'CurrentUserProfile';
  admin?: Maybe<Scalars['Boolean']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  downloadMessage?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  features?: Maybe<Scalars['JSON']['output']>;
  featuresEntitled?: Maybe<Array<Scalars['String']['output']>>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jwtToken?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mapCcusTilesetSources: Array<Scalars['JSON']['output']>;
  mapTilesetSources: Array<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  seenUserWelcome?: Maybe<Scalars['Boolean']['output']>;
  signInCount?: Maybe<Scalars['Int']['output']>;
  subscribedCountries?: Maybe<Array<Country>>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type DataDownload = {
  __typename?: 'DataDownload';
  assets?: Maybe<Array<Asset>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
  wells?: Maybe<Array<Well>>;
};

/** Autogenerated return type of DeleteUserFilterMutation. */
export type DeleteUserFilterMutationPayload = {
  __typename?: 'DeleteUserFilterMutationPayload';
  errors: Array<Scalars['String']['output']>;
  userFilter?: Maybe<UserFilter>;
};

export type DevelopmentStatus = {
  __typename?: 'DevelopmentStatus';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  isDisabled?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type DevelopmentType = {
  __typename?: 'DevelopmentType';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type DimAsset = {
  __typename?: 'DimAsset';
  country: Country;
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type DimAssetUnits = {
  __typename?: 'DimAssetUnits';
  companyName: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isoCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  optionDisplayName: Scalars['String']['output'];
  percentStake: Scalars['String']['output'];
};

export type DimBasin = {
  __typename?: 'DimBasin';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type DimCcusDevelopmentStatus = {
  __typename?: 'DimCcusDevelopmentStatus';
  developmentStatus: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type DimCcusProject = {
  __typename?: 'DimCcusProject';
  announcedCapacity?: Maybe<Scalars['String']['output']>;
  announcementYear?: Maybe<Scalars['Int']['output']>;
  countryIso: Scalars['String']['output'];
  countryName?: Maybe<Scalars['String']['output']>;
  developmentLikelihood?: Maybe<Scalars['String']['output']>;
  developmentStatus?: Maybe<Scalars['String']['output']>;
  fidYear?: Maybe<Scalars['Int']['output']>;
  formattedPartners?: Maybe<Scalars['String']['output']>;
  geom?: Maybe<Scalars['JSON']['output']>;
  hubName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  industryType?: Maybe<Scalars['String']['output']>;
  operationalYear?: Maybe<Scalars['Int']['output']>;
  projectDescription?: Maybe<Scalars['String']['output']>;
  projectName: Scalars['String']['output'];
  projectScale?: Maybe<Scalars['String']['output']>;
  projectType?: Maybe<Scalars['String']['output']>;
  storagePartnership?: Maybe<Scalars['String']['output']>;
  storageType?: Maybe<Scalars['String']['output']>;
};

export type DimCcusProjectQuery = {
  __typename?: 'DimCcusProjectQuery';
  ccusProjects: Array<DimCcusProject>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type DimCcusProjectScale = {
  __typename?: 'DimCcusProjectScale';
  id: Scalars['ID']['output'];
  projectScale: Scalars['String']['output'];
};

export type DimCcusProjectType = {
  __typename?: 'DimCcusProjectType';
  id: Scalars['ID']['output'];
  projectType: Scalars['String']['output'];
};

export type DimCcusSeparationType = {
  __typename?: 'DimCcusSeparationType';
  id: Scalars['ID']['output'];
  separationType: Scalars['String']['output'];
};

export type DimCompany = {
  __typename?: 'DimCompany';
  companyName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type DimCompanyQuery = {
  __typename?: 'DimCompanyQuery';
  companies: Array<DimCompany>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type DimCompanyTarget = {
  __typename?: 'DimCompanyTarget';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type DimFacility = {
  __typename?: 'DimFacility';
  countryIso: Scalars['String']['output'];
  countryName?: Maybe<Scalars['String']['output']>;
  dimIndustry: DimIndustry;
  facilityName: Scalars['String']['output'];
  facilitySubtype?: Maybe<Scalars['String']['output']>;
  formattedBiogenicCo2Emission?: Maybe<Scalars['String']['output']>;
  formattedCo2Emission?: Maybe<Scalars['String']['output']>;
  formattedOwners?: Maybe<Scalars['String']['output']>;
  formattedProcessEmission?: Maybe<Scalars['String']['output']>;
  formattedStationaryEmission?: Maybe<Scalars['String']['output']>;
  geom?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  industryType?: Maybe<Scalars['String']['output']>;
};

export type DimFacilityDownload = {
  __typename?: 'DimFacilityDownload';
  facility: DimFacility;
  hasDownload?: Maybe<Scalars['Boolean']['output']>;
};

export type DimFacilityQuery = {
  __typename?: 'DimFacilityQuery';
  facilities: Array<DimFacility>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type DimIndustry = {
  __typename?: 'DimIndustry';
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type DimShoreStatus = {
  __typename?: 'DimShoreStatus';
  id: Scalars['ID']['output'];
  shoreStatus: Scalars['String']['output'];
};

export type DimStorageBlockStatus = {
  __typename?: 'DimStorageBlockStatus';
  blockStatus: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type DimStorageSite = {
  __typename?: 'DimStorageSite';
  acreage?: Maybe<Scalars['String']['output']>;
  blockStatus?: Maybe<Scalars['String']['output']>;
  countryIso: Scalars['String']['output'];
  formattedAcreage?: Maybe<Scalars['String']['output']>;
  formattedPartners?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  shoreStatus?: Maybe<Scalars['String']['output']>;
  storageSiteName: Scalars['String']['output'];
  storageType?: Maybe<Scalars['String']['output']>;
};

export type DimStorageSiteDownload = {
  __typename?: 'DimStorageSiteDownload';
  hasDownload?: Maybe<Scalars['Boolean']['output']>;
  storageSite: DimStorageSite;
};

export type DimStorageSiteQuery = {
  __typename?: 'DimStorageSiteQuery';
  storageSites: Array<DimStorageSite>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type DimStorageType = {
  __typename?: 'DimStorageType';
  id: Scalars['ID']['output'];
  storageType?: Maybe<Scalars['String']['output']>;
};

/** Represents a country in the data ingestion tool */
export type DitCountry = {
  __typename?: 'DitCountry';
  /** ISO code of the country */
  isoCode: Scalars['String']['output'];
  /** Name of the country */
  name: Scalars['String']['output'];
  /** List of sources available for the country */
  sources?: Maybe<Array<Source>>;
};

export type DownloadHistory = {
  __typename?: 'DownloadHistory';
  createdAt: Scalars['ISO8601DateTime']['output'];
  filename: Scalars['String']['output'];
  finishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  presignedUrl?: Maybe<Scalars['String']['output']>;
  requestedAt: Scalars['ISO8601DateTime']['output'];
  s3Key: Scalars['String']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  userId: Scalars['ID']['output'];
};

export type EaWell = {
  __typename?: 'EaWell';
  basinName?: Maybe<Scalars['String']['output']>;
  blockName?: Maybe<Scalars['String']['output']>;
  country: Country;
  drillStart?: Maybe<Scalars['ISO8601Date']['output']>;
  entityType: Scalars['String']['output'];
  estimatedCoordinates?: Maybe<Scalars['Boolean']['output']>;
  estimatedCost?: Maybe<Scalars['Float']['output']>;
  expectedSpudQuarter?: Maybe<Scalars['String']['output']>;
  fieldName?: Maybe<Scalars['String']['output']>;
  flexParticipations?: Maybe<Array<FlexParticipation>>;
  formattedEstimatedCost?: Maybe<Scalars['String']['output']>;
  formattedHydrocarbonTarget: Scalars['String']['output'];
  formattedImpact: Scalars['String']['output'];
  formattedProspectSize: Scalars['String']['output'];
  formattedShoreStatus: Scalars['String']['output'];
  formattedWellType: Scalars['String']['output'];
  geologicalTarget?: Maybe<Scalars['String']['output']>;
  geom: Scalars['JSON']['output'];
  hostFacilityName?: Maybe<Scalars['String']['output']>;
  hydrocarbonTarget: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  impact: Scalars['String']['output'];
  isCommitment: Scalars['Boolean']['output'];
  leaseName?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  prospect?: Maybe<Scalars['String']['output']>;
  prospectSize: Scalars['String']['output'];
  region?: Maybe<Scalars['String']['output']>;
  rigName?: Maybe<Scalars['String']['output']>;
  shoreStatus: Scalars['String']['output'];
  targetDepthM?: Maybe<Scalars['Float']['output']>;
  waterDepthM?: Maybe<Scalars['Float']['output']>;
  wellType: Scalars['String']['output'];
};

export type EntityIdentifierInput = {
  feature?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type EntityName = {
  __typename?: 'EntityName';
  entityUuid: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
};

export enum EntityTypeEnum {
  /** Entity type for Asset */
  Asset = 'Asset',
  /** Entity type for Basin */
  Basin = 'Basin',
  /** Entity type for Block */
  Block = 'Block',
  /** Entity type for Company */
  Company = 'Company',
  /** Entity type for Country */
  Country = 'Country',
  /** Entity type for DimCcusProject */
  DimCcusProject = 'DimCcusProject',
  /** Entity type for DimStorageSite */
  DimStorageSite = 'DimStorageSite',
  /** Entity type for Facility */
  Facility = 'Facility',
  /** Entity type for Field */
  Field = 'Field',
  /** Entity type for Lease */
  Lease = 'Lease',
  /** Entity type for Pipeline */
  Pipeline = 'Pipeline',
  /** Entity type for SearchableReport */
  SearchableReport = 'SearchableReport',
  /** Entity type for Well */
  Well = 'Well'
}

export type Facility = {
  __typename?: 'Facility';
  alternativeTypeName?: Maybe<Scalars['String']['output']>;
  assets?: Maybe<Array<Asset>>;
  basin?: Maybe<Basin>;
  commonFacilityProperties?: Maybe<Scalars['JSON']['output']>;
  company?: Maybe<Company>;
  contractType?: Maybe<Scalars['String']['output']>;
  country: Country;
  createdAt: Scalars['ISO8601DateTime']['output'];
  crudeStorageBbl?: Maybe<Scalars['Float']['output']>;
  derivedCapacity?: Maybe<Scalars['Float']['output']>;
  facilityIcon?: Maybe<FacilityIcon>;
  formattedGasCapacity?: Maybe<Scalars['String']['output']>;
  formattedGasThroughputRecentMmcfd?: Maybe<Scalars['String']['output']>;
  formattedLiquidsThroughputRecentBbld?: Maybe<Scalars['String']['output']>;
  formattedOilCapacity?: Maybe<Scalars['String']['output']>;
  formattedOilThroughputRecentBbld?: Maybe<Scalars['String']['output']>;
  formattedPowerPlantCapacityMw?: Maybe<Scalars['String']['output']>;
  formattedWaterDepth?: Maybe<Scalars['String']['output']>;
  formattedWaterInjectionCapacity?: Maybe<Scalars['String']['output']>;
  formattedWaterThroughputRecentBbld?: Maybe<Scalars['String']['output']>;
  formattedWaterTreatingProcessingCapacity?: Maybe<Scalars['String']['output']>;
  gasCapacity?: Maybe<Scalars['Float']['output']>;
  gasThroughputRecentMmcfd?: Maybe<Scalars['Float']['output']>;
  geom: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  installDate?: Maybe<Scalars['ISO8601Date']['output']>;
  legacyId: Scalars['ID']['output'];
  liquidsThroughputRecentBbld?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  oilCapacity?: Maybe<Scalars['Float']['output']>;
  oilThroughputRecentBbld?: Maybe<Scalars['Float']['output']>;
  shoreStatus?: Maybe<Scalars['String']['output']>;
  startUp?: Maybe<Scalars['ISO8601Date']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  throughputRecentDate?: Maybe<Scalars['ISO8601Date']['output']>;
  typeName?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  waterDepth?: Maybe<Scalars['Int']['output']>;
  waterInjectionCapacity?: Maybe<Scalars['Float']['output']>;
  waterThroughputRecentBbld?: Maybe<Scalars['Float']['output']>;
  waterTreatingProcessingCapacity?: Maybe<Scalars['Float']['output']>;
};

export type FacilityIcon = {
  __typename?: 'FacilityIcon';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type FacilityQuery = {
  __typename?: 'FacilityQuery';
  facilities: Array<Facility>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type FactFacilityEmissionMaxValues = {
  __typename?: 'FactFacilityEmissionMaxValues';
  maxAbatementCost?: Maybe<Scalars['Int']['output']>;
  maxCaptureCost?: Maybe<Scalars['Int']['output']>;
  maxCo2Emission?: Maybe<Scalars['Int']['output']>;
  maxStorageCost?: Maybe<Scalars['Int']['output']>;
  maxTransportationCost?: Maybe<Scalars['Int']['output']>;
};

export enum FeatureEnum {
  /** CCUS */
  Ccus = 'ccus',
  /** CCUS Intelligence Notes */
  CcusNotes = 'ccusNotes',
  /** Consolidated Live Models - Advanced portfolio modeling and analysis */
  ConsolidatedLiveModels = 'consolidatedLiveModels',
  /** Greenhouse gas analytics */
  Ghg = 'ghg',
  /** Greenhouse gas analytics scope 3 */
  GhgScope3 = 'ghgScope3',
  /** Intelligence Notes */
  IntelligenceNotes = 'intelligenceNotes',
  /** US Lower 48 Upstream - Automatically assigns US Lower 48 country areas and all available features */
  Lower48Upstream = 'lower48Upstream',
  /** M&A Deal Notes */
  MAndANotes = 'mAndANotes',
  /** M&A Opportunities */
  MAndAOpportunities = 'mAndAOpportunities',
  /** M&A Transactions */
  MAndATransactions = 'mAndATransactions',
  /** Oil and Gas Map */
  OilAndGasMap = 'oilAndGasMap',
  /** Portfolio Analysis */
  PortfolioAnalysis = 'portfolioAnalysis',
  /** Basic Welligence Subscription inluding Valuation Models, Country Overviews */
  WebPlatform = 'webPlatform'
}

export type Field = {
  __typename?: 'Field';
  assets?: Maybe<Array<Asset>>;
  basin?: Maybe<Basin>;
  blocks?: Maybe<Array<Block>>;
  country: Country;
  createdAt: Scalars['ISO8601DateTime']['output'];
  developmentStatus?: Maybe<DevelopmentStatus>;
  developmentType?: Maybe<DevelopmentType>;
  discoveryDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  discoveryWell?: Maybe<Well>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  fieldStatus?: Maybe<FieldStatus>;
  firstProductionDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  formattedAcreage?: Maybe<Scalars['String']['output']>;
  formattedWaterDepth?: Maybe<Scalars['String']['output']>;
  formattedWaterDepthMax?: Maybe<Scalars['String']['output']>;
  formattedWaterDepthMin?: Maybe<Scalars['String']['output']>;
  geom?: Maybe<Scalars['JSON']['output']>;
  hydrocarbonType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  legacyId: Scalars['ID']['output'];
  licensingRound?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  participations?: Maybe<Array<Participation>>;
  productionCessationDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  projectSanctionDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  resourceTheme?: Maybe<ResourceTheme>;
  shoreStatus?: Maybe<ShoreStatus>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  uuid: Scalars['ID']['output'];
  waterDepthM?: Maybe<Scalars['Int']['output']>;
  waterDepthMMax?: Maybe<Scalars['Int']['output']>;
  waterDepthMMin?: Maybe<Scalars['Int']['output']>;
  wells?: Maybe<Array<Well>>;
};

export type FieldStatus = {
  __typename?: 'FieldStatus';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type FiltersAssetInput = {
  countryIsoCode?: InputMaybe<Scalars['String']['input']>;
  legacyId?: InputMaybe<Scalars['Int']['input']>;
};

export type FiscalRegime = {
  __typename?: 'FiscalRegime';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type FlexParticipation = {
  __typename?: 'FlexParticipation';
  comment?: Maybe<Scalars['String']['output']>;
  companyName: Scalars['String']['output'];
  formattedPercentStake?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isCompanyOperator: Scalars['Boolean']['output'];
  percentStake: Scalars['Float']['output'];
};

export type Formation = {
  __typename?: 'Formation';
  country: Country;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  legacyId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type FracStage = {
  __typename?: 'FracStage';
  co2InjectedM3?: Maybe<Scalars['Float']['output']>;
  completionType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  fractureEnd?: Maybe<Scalars['ISO8601DateTime']['output']>;
  fractureStart?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  importedSandPumpedTn?: Maybe<Scalars['Float']['output']>;
  lateralLengthM?: Maybe<Scalars['Float']['output']>;
  maxPressurePsi?: Maybe<Scalars['Float']['output']>;
  nationalSandPumpedTn?: Maybe<Scalars['Float']['output']>;
  numFractures?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  waterInjectedBbl?: Maybe<Scalars['Float']['output']>;
  well: Well;
};

export type FulltextReportsSearchResult = {
  __typename?: 'FulltextReportsSearchResult';
  actions: Array<Scalars['String']['output']>;
  date: Scalars['String']['output'];
  description: Scalars['String']['output'];
  entity: Scalars['String']['output'];
  id: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rank: Scalars['Float']['output'];
  rows: Array<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

/** Input object to use selected labels */
export type FulltextSearchFilterInput = {
  labelGroups?: InputMaybe<Array<FulltextSearchFilterLabelGroupInput>>;
};

export type FulltextSearchFilterLabelGroupInput = {
  labels: Array<Scalars['String']['input']>;
};

export type FulltextSearchResult = {
  __typename?: 'FulltextSearchResult';
  actions: Array<Scalars['String']['output']>;
  countryGeom?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  entity: Scalars['String']['output'];
  geom?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isoCode?: Maybe<Scalars['String']['output']>;
  linkId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rank: Scalars['Float']['output'];
};

export type Geology = {
  __typename?: 'Geology';
  age?: Maybe<GeologyAge>;
  avgReservoirDepthM?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  epoch?: Maybe<GeologyEpoch>;
  epochCardinality?: Maybe<Scalars['Int']['output']>;
  era?: Maybe<GeologyEra>;
  formation?: Maybe<GeologyFormation>;
  id: Scalars['ID']['output'];
  isHpht?: Maybe<Scalars['Boolean']['output']>;
  lithologies?: Maybe<Array<Lithology>>;
  name?: Maybe<Scalars['String']['output']>;
  period?: Maybe<GeologyPeriod>;
  play?: Maybe<GeologyPlay>;
  primaryFormation?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type GeologyAge = {
  __typename?: 'GeologyAge';
  cardinality?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  epoch?: Maybe<GeologyEpoch>;
  formations?: Maybe<Array<GeologyFormation>>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type GeologyEpoch = {
  __typename?: 'GeologyEpoch';
  ages?: Maybe<Array<GeologyAge>>;
  cardinality?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  period?: Maybe<GeologyPeriod>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type GeologyEra = {
  __typename?: 'GeologyEra';
  cardinality?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  periods?: Maybe<Array<GeologyPeriod>>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type GeologyFormation = {
  __typename?: 'GeologyFormation';
  age?: Maybe<GeologyAge>;
  cardinality?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  plays?: Maybe<Array<GeologyPlay>>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type GeologyPeriod = {
  __typename?: 'GeologyPeriod';
  cardinality?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  epochs?: Maybe<Array<GeologyEpoch>>;
  era?: Maybe<GeologyEra>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type GeologyPlay = {
  __typename?: 'GeologyPlay';
  cardinality?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  formation?: Maybe<GeologyFormation>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated return type of GetGisFileDownloadUrlMutation. */
export type GetGisFileDownloadUrlMutationPayload = {
  __typename?: 'GetGisFileDownloadUrlMutationPayload';
  errors: Array<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GhgFilter = {
  __typename?: 'GhgFilter';
  assetUnits?: Maybe<Array<DimAssetUnits>>;
  assets?: Maybe<Array<DimAsset>>;
  basins?: Maybe<Array<DimBasin>>;
  companies?: Maybe<Array<DimCompany>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type GisFile = {
  __typename?: 'GisFile';
  country?: Maybe<Country>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdBy: User;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPublished: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  publishedBy?: Maybe<User>;
  region?: Maybe<Region>;
  s3Bucket: Scalars['String']['output'];
  s3Key: Scalars['String']['output'];
  uid: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type GisFilesResponse = {
  __typename?: 'GisFilesResponse';
  files: Array<GisFile>;
  totalCount: Scalars['Int']['output'];
};

export type GlobalAssumptions = {
  __typename?: 'GlobalAssumptions';
  allModelsMatchBaseYear?: Maybe<Scalars['String']['output']>;
  baseYear?: Maybe<Scalars['String']['output']>;
  brentPriceBaseYear?: Maybe<Scalars['String']['output']>;
  brentPriceBaseYearPlusOne?: Maybe<Scalars['String']['output']>;
  brentPriceBaseYearPlusTwo?: Maybe<Scalars['String']['output']>;
  costInflation?: Maybe<Scalars['String']['output']>;
  discountRate?: Maybe<Scalars['String']['output']>;
};

export type GraphFacilityProduction = {
  __typename?: 'GraphFacilityProduction';
  gas: Array<Array<Maybe<Scalars['Float']['output']>>>;
  gasLabels: Array<Scalars['String']['output']>;
  liquids: Array<Array<Maybe<Scalars['Float']['output']>>>;
  liquidsLabels: Array<Scalars['String']['output']>;
};

export type GraphPipelineNetworkThroughput = {
  __typename?: 'GraphPipelineNetworkThroughput';
  labels: Array<Scalars['String']['output']>;
  throughputs: Array<Array<Maybe<Scalars['Float']['output']>>>;
  ylabel: Scalars['String']['output'];
};

export type GraphPipelineThroughput = {
  __typename?: 'GraphPipelineThroughput';
  labels: Array<Scalars['String']['output']>;
  throughputs: Array<Array<Maybe<Scalars['Float']['output']>>>;
  ylabel: Scalars['String']['output'];
};

export type GroupedParticipation = {
  __typename?: 'GroupedParticipation';
  A?: Maybe<Array<Participation>>;
  B?: Maybe<Array<Participation>>;
  C?: Maybe<Array<Participation>>;
  D?: Maybe<Array<Participation>>;
  E?: Maybe<Array<Participation>>;
  O?: Maybe<Array<Participation>>;
  S?: Maybe<Array<Participation>>;
  noGroup?: Maybe<Array<Participation>>;
};

export type IndustryTracker = {
  __typename?: 'IndustryTracker';
  name: Scalars['String']['output'];
  regions: Array<IndustryTrackerRegion>;
  type: IndustryTrackerTypeEnum;
  userEntitledRegions?: Maybe<Array<Scalars['String']['output']>>;
};

export type IndustryTrackerRegion = {
  __typename?: 'IndustryTrackerRegion';
  displayName?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export enum IndustryTrackerTypeEnum {
  /** CAPEX_GUIDANCE_TRACKER industry tracker */
  CapexGuidanceTracker = 'CAPEX_GUIDANCE_TRACKER',
  /** ENERGY_TRANSITION_TARGETS_TRACKER industry tracker */
  EnergyTransitionTargetsTracker = 'ENERGY_TRANSITION_TARGETS_TRACKER',
  /** EXPLORATION_AND_APPRAISAL_WELL_TRACKER industry tracker */
  ExplorationAndAppraisalWellTracker = 'EXPLORATION_AND_APPRAISAL_WELL_TRACKER',
  /** LICENSING_ROUND_AND_DRO_TRACKER industry tracker */
  LicensingRoundAndDroTracker = 'LICENSING_ROUND_AND_DRO_TRACKER',
  /** LNG_FACILITIES industry tracker */
  LngFacilities = 'LNG_FACILITIES',
  /** POTENTIAL_MA_OPPORTUNITIES industry tracker */
  PotentialMaOpportunities = 'POTENTIAL_MA_OPPORTUNITIES'
}

/** Represents a Nexus job */
export type Job = {
  __typename?: 'Job';
  areaCode: Scalars['String']['output'];
  bucket: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  fileStructure?: Maybe<Scalars['JSON']['output']>;
  /** Unique identifier for the job */
  id: Scalars['ID']['output'];
  /** Status message for the job */
  message?: Maybe<Scalars['String']['output']>;
  outputS3keys?: Maybe<Array<Scalars['String']['output']>>;
  previousJobId?: Maybe<Scalars['String']['output']>;
  region: Scalars['String']['output'];
  reportName: Scalars['String']['output'];
  s3Keys?: Maybe<Array<Scalars['String']['output']>>;
  startedBy: Scalars['String']['output'];
  startedByRegion: Scalars['String']['output'];
  status: Scalars['String']['output'];
  step: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type JobsFilters = {
  __typename?: 'JobsFilters';
  areaCodes?: Maybe<Array<Scalars['String']['output']>>;
  jobStatuses?: Maybe<Array<Scalars['String']['output']>>;
  regions?: Maybe<Array<Scalars['String']['output']>>;
  reportNames?: Maybe<Array<Scalars['String']['output']>>;
  startedBy?: Maybe<Array<Scalars['String']['output']>>;
  steps?: Maybe<Array<Scalars['String']['output']>>;
};

export type LeadAnalyst = {
  __typename?: 'LeadAnalyst';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Lease = {
  __typename?: 'Lease';
  areaCode?: Maybe<Scalars['String']['output']>;
  bidAmountMmusd?: Maybe<Scalars['Float']['output']>;
  blockNumber?: Maybe<Scalars['String']['output']>;
  country: Country;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currentParticipationDates?: Maybe<Scalars['JSON']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  effectiveDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  entityType: Scalars['String']['output'];
  expirationDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  formattedBidAmountMmusd?: Maybe<Scalars['String']['output']>;
  formattedLiabilityMmusd?: Maybe<Scalars['String']['output']>;
  formattedRecentProductionGasMmcfd?: Maybe<Scalars['String']['output']>;
  formattedRecentProductionLiquidsBbld?: Maybe<Scalars['String']['output']>;
  formattedWaterDepth?: Maybe<Scalars['String']['output']>;
  formattedWaterDepthM?: Maybe<Scalars['String']['output']>;
  geom?: Maybe<Scalars['JSON']['output']>;
  groupedParticipations?: Maybe<GroupedParticipation>;
  id: Scalars['ID']['output'];
  leaseStatus?: Maybe<LeaseStatus>;
  legacyId: Scalars['ID']['output'];
  liabilityMmusd?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  participations?: Maybe<Array<Participation>>;
  primaryTermYears?: Maybe<Scalars['Int']['output']>;
  recentProductionDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  recentProductionGasMmcfd?: Maybe<Scalars['String']['output']>;
  recentProductionLiquidsBbld?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  waterDepthM?: Maybe<Scalars['Float']['output']>;
};

export type LeaseStatus = {
  __typename?: 'LeaseStatus';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type LicensingRound = {
  __typename?: 'LicensingRound';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Lithology = {
  __typename?: 'Lithology';
  createdAt: Scalars['ISO8601DateTime']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type LngLiquefaction = {
  __typename?: 'LngLiquefaction';
  capacityMmtpa?: Maybe<Scalars['Float']['output']>;
  country: Country;
  id: Scalars['ID']['output'];
  lngProject: LngProject;
  lngTrains: Array<LngTrain>;
  numberOfTrains?: Maybe<Scalars['Int']['output']>;
};

export type LngLiquefactionTechnology = {
  __typename?: 'LngLiquefactionTechnology';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type LngProject = {
  __typename?: 'LngProject';
  category: Scalars['String']['output'];
  country: Country;
  formattedStorageCapacityM3?: Maybe<Scalars['String']['output']>;
  geom: Scalars['JSON']['output'];
  iconName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lngLiquefaction?: Maybe<LngLiquefaction>;
  lngRegas?: Maybe<LngRegas>;
  lngShoreStatus: Scalars['String']['output'];
  lngStatus: Scalars['String']['output'];
  lngType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  numberOfStorageTanks?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  storageCapacityM3?: Maybe<Scalars['Float']['output']>;
  waterDepthM?: Maybe<Scalars['Int']['output']>;
};

export type LngRegas = {
  __typename?: 'LngRegas';
  costMmusd?: Maybe<Scalars['Float']['output']>;
  flexParticipations?: Maybe<Array<FlexParticipation>>;
  id: Scalars['ID']['output'];
  lngProject: LngProject;
  nominalSendOutCapacity: Scalars['Float']['output'];
};

export type LngTrain = {
  __typename?: 'LngTrain';
  costMmusd?: Maybe<Scalars['Float']['output']>;
  feedGasSupplyAssets?: Maybe<Array<Scalars['String']['output']>>;
  fetchedFeedGasSupplyAssets?: Maybe<Array<Asset>>;
  flexParticipations?: Maybe<Array<FlexParticipation>>;
  id: Scalars['ID']['output'];
  lngLiquefaction: LngLiquefaction;
  lngLiquefactionTechnology: LngLiquefactionTechnology;
  name: Scalars['String']['output'];
  nominalLiquefactionCapacity?: Maybe<Scalars['Float']['output']>;
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  status: Scalars['String']['output'];
};

export type LoadPortfolio = {
  __typename?: 'LoadPortfolio';
  portfolios?: Maybe<Array<UserPortfolio>>;
  sharedPortfolios?: Maybe<Array<UserPortfolio>>;
};

export type LoadPriceDecks = {
  __typename?: 'LoadPriceDecks';
  priceDecks?: Maybe<Array<UserPriceDeck>>;
};

/** Autogenerated return type of Login. */
export type LoginPayload = {
  __typename?: 'LoginPayload';
  authenticatable?: Maybe<Authenticatable>;
  credentials?: Maybe<Credential>;
  errors?: Maybe<Scalars['String']['output']>;
};

export enum MaAggregateByEnum {
  Buyer = 'buyer',
  Country = 'country',
  Seller = 'seller',
  Year = 'year'
}

export type MaAggregates = {
  __typename?: 'MaAggregates';
  acquisitionCostSum: Scalars['Float']['output'];
  countSum: Scalars['Int']['output'];
  group: Scalars['String']['output'];
  productionsSum: Scalars['Float']['output'];
  reservesSum: Scalars['Float']['output'];
  type: MaAggregateByEnum;
  valuationsSum: Scalars['Float']['output'];
};

export type MaAggregatesStacked = {
  __typename?: 'MaAggregatesStacked';
  data: Array<MaAggregatesStackedData>;
  stacks: Array<Scalars['String']['output']>;
};

export type MaAggregatesStackedData = {
  __typename?: 'MaAggregatesStackedData';
  group: Scalars['String']['output'];
  type: MaAggregateByEnum;
  values: Scalars['JSON']['output'];
};

export type MaAsset = {
  __typename?: 'MaAsset';
  acreage?: Maybe<Scalars['Float']['output']>;
  basin?: Maybe<Basin>;
  basinId?: Maybe<Scalars['ID']['output']>;
  country: Country;
  countryId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['ID']['output']>;
  entityType: MaAssetEntityTypeEnum;
  geom?: Maybe<Scalars['JSON']['output']>;
  hydrocarbonType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  legacyId?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  shoreStatus?: Maybe<ShoreStatus>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  waterDepthM?: Maybe<Scalars['Float']['output']>;
};

export enum MaAssetEntityTypeEnum {
  /** The MaAssetTransaction refers to an asset */
  Asset = 'asset',
  /** The MaAssetTransaction refers to a block */
  Block = 'block',
  /** The MaAssetTransaction refers to a field */
  Field = 'field',
  /** The asset_name from the MaAssetTransaction could not be matched to a known entity type. */
  Unknown = 'unknown'
}

export type MaAssetQuery = {
  __typename?: 'MaAssetQuery';
  assets: Array<MaAsset>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type MaAssetTransaction = {
  __typename?: 'MaAssetTransaction';
  assetName?: Maybe<Scalars['String']['output']>;
  assetStatus?: Maybe<Scalars['String']['output']>;
  buyerStakeAfter?: Maybe<Scalars['Float']['output']>;
  buyerStakeBefore?: Maybe<Scalars['Float']['output']>;
  country?: Maybe<Country>;
  countryId: Scalars['Int']['output'];
  countryName: Scalars['String']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  maCompanyTransaction?: Maybe<MaCompanyTransaction>;
  regionName: Scalars['String']['output'];
  sellerStakeAfter?: Maybe<Scalars['Float']['output']>;
  sellerStakeBefore?: Maybe<Scalars['Float']['output']>;
  shoreStatus?: Maybe<Scalars['String']['output']>;
  weaConsiderationByProduction?: Maybe<Scalars['Float']['output']>;
  weaConsiderationByReserves?: Maybe<Scalars['Float']['output']>;
  weaCurrentEmissionsIntensity?: Maybe<Scalars['Float']['output']>;
  weaPriceFlowingBarrel?: Maybe<Scalars['Float']['output']>;
  weaRemainingEmissionsIntensity?: Maybe<Scalars['Float']['output']>;
  weaReservesAcquisitionCost?: Maybe<Scalars['Float']['output']>;
  weaUsdFlowingBbl?: Maybe<Scalars['Float']['output']>;
  weaWorkingInterestCurrentEmissions?: Maybe<Scalars['Float']['output']>;
  weaWorkingInterestGasProduction?: Maybe<Scalars['Float']['output']>;
  weaWorkingInterestGasReserves?: Maybe<Scalars['Float']['output']>;
  weaWorkingInterestLiquidsProduction?: Maybe<Scalars['Float']['output']>;
  weaWorkingInterestLiquidsReserves?: Maybe<Scalars['Float']['output']>;
  weaWorkingInterestProduction?: Maybe<Scalars['Float']['output']>;
  weaWorkingInterestRemainingEmissions?: Maybe<Scalars['Float']['output']>;
  weaWorkingInterestReserves?: Maybe<Scalars['Float']['output']>;
  weaWorkingInterestValuation?: Maybe<Scalars['Float']['output']>;
  workingInterest?: Maybe<Scalars['Float']['output']>;
};

export type MaCompanyTransaction = {
  __typename?: 'MaCompanyTransaction';
  buyerCompany?: Maybe<Company>;
  buyerCompanyId?: Maybe<Scalars['Int']['output']>;
  buyerCompanyName?: Maybe<Scalars['String']['output']>;
  buyerMotivation?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  maAssetTransactions?: Maybe<Array<MaAssetTransaction>>;
  maAssetTransactionsCount?: Maybe<Scalars['Int']['output']>;
  maDeal?: Maybe<MaDeal>;
  sellerCompany?: Maybe<Company>;
  sellerCompanyId?: Maybe<Scalars['Int']['output']>;
  sellerCompanyName?: Maybe<Scalars['String']['output']>;
  sellerMotivation?: Maybe<Scalars['String']['output']>;
  soldCompany?: Maybe<Company>;
  soldCompanyId?: Maybe<Scalars['Int']['output']>;
  soldCompanyName?: Maybe<Scalars['String']['output']>;
  stakeSold?: Maybe<Scalars['Float']['output']>;
};

export type MaDeal = {
  __typename?: 'MaDeal';
  comment?: Maybe<Scalars['String']['output']>;
  considerationMmusd?: Maybe<Scalars['Int']['output']>;
  dealAssetName?: Maybe<Scalars['String']['output']>;
  dealBuyerCompanyName?: Maybe<Scalars['String']['output']>;
  dealConsiderationByProduction?: Maybe<Scalars['Float']['output']>;
  dealConsiderationByReserves?: Maybe<Scalars['Float']['output']>;
  dealCountryName?: Maybe<Scalars['String']['output']>;
  dealCurrentEmissionsIntensity?: Maybe<Scalars['Float']['output']>;
  dealPriceFlowingBarrel?: Maybe<Scalars['Float']['output']>;
  dealRegionName?: Maybe<Scalars['String']['output']>;
  dealRemainingEmissionsIntensity?: Maybe<Scalars['Float']['output']>;
  dealReservesAcquisitionCost?: Maybe<Scalars['Float']['output']>;
  dealSellerCompanyName?: Maybe<Scalars['String']['output']>;
  dealShoreStatus?: Maybe<Scalars['String']['output']>;
  dealType: Scalars['String']['output'];
  dealWorkingInterest?: Maybe<Scalars['Float']['output']>;
  dealWorkingInterestGasProduction?: Maybe<Scalars['Float']['output']>;
  dealWorkingInterestGasReserves?: Maybe<Scalars['Float']['output']>;
  dealWorkingInterestLiquidsProduction?: Maybe<Scalars['Float']['output']>;
  dealWorkingInterestLiquidsReserves?: Maybe<Scalars['Float']['output']>;
  dealWorkingInterestProduction?: Maybe<Scalars['Float']['output']>;
  dealWorkingInterestReserves?: Maybe<Scalars['Float']['output']>;
  dealWorkingInterestValuation?: Maybe<Scalars['Float']['output']>;
  effectiveDate: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  maAssetTransactionsCount?: Maybe<Scalars['Int']['output']>;
  maCompanyTransactions?: Maybe<Array<MaCompanyTransaction>>;
  maCompanyTransactionsCount?: Maybe<Scalars['Int']['output']>;
  maDealDetails?: Maybe<MaDealDetails>;
};

export type MaDealDetails = {
  __typename?: 'MaDealDetails';
  acreage?: Maybe<Scalars['Float']['output']>;
  announcementDate?: Maybe<Scalars['ISO8601Date']['output']>;
  buySideAdvisor?: Maybe<Scalars['String']['output']>;
  closingDate?: Maybe<Scalars['ISO8601Date']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  dealStatus?: Maybe<MaDealStatusEnum>;
  dealType: Scalars['String']['output'];
  effectiveDate: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  maDeal: MaDeal;
  maDealId: Scalars['Int']['output'];
  paymentType?: Maybe<MaDealPaymentTypeEnum>;
  reportedAcreageAcquisitionCostUsdPerAcre?: Maybe<Scalars['Float']['output']>;
  reportedConsiderationBaseCashMmusd?: Maybe<Scalars['Float']['output']>;
  reportedConsiderationBaseEquityMmusd?: Maybe<Scalars['Float']['output']>;
  reportedConsiderationComment?: Maybe<Scalars['String']['output']>;
  reportedConsiderationContingentMmusd?: Maybe<Scalars['Float']['output']>;
  reportedConsiderationTotalMmusd?: Maybe<Scalars['Float']['output']>;
  reportedCostCarryMmusd?: Maybe<Scalars['Float']['output']>;
  reportedCostCommitmentMmusd?: Maybe<Scalars['Float']['output']>;
  reportedCurrentEmissionsIntensityKgco2ePerBoe?: Maybe<Scalars['Float']['output']>;
  reportedDebtMmusd?: Maybe<Scalars['Float']['output']>;
  reportedGasProductionMmcfd?: Maybe<Scalars['Float']['output']>;
  reportedOilCondensateProductionBbld?: Maybe<Scalars['Float']['output']>;
  reportedPricePerFlowingBarrelUsdPerBoed?: Maybe<Scalars['Float']['output']>;
  reportedProductionBoed?: Maybe<Scalars['Float']['output']>;
  reportedRemainingEmissionsIntensityKgco2ePerBoe?: Maybe<Scalars['Float']['output']>;
  reportedReservesAcquisitionCostUsdPerBoe?: Maybe<Scalars['Float']['output']>;
  reportedSignatureBonusMmusd?: Maybe<Scalars['Float']['output']>;
  reportedTransacted1pGasReservesBcf?: Maybe<Scalars['Float']['output']>;
  reportedTransacted1pOilCondensateReservesMmbbl?: Maybe<Scalars['Float']['output']>;
  reportedTransacted1pReservesMmboe?: Maybe<Scalars['Float']['output']>;
  reportedTransacted2cGasResourceBcf?: Maybe<Scalars['Float']['output']>;
  reportedTransacted2cOilCondensateResourceMmbbl?: Maybe<Scalars['Float']['output']>;
  reportedTransacted2cResourceMmboe?: Maybe<Scalars['Float']['output']>;
  reportedTransacted2pGasReservesBcf?: Maybe<Scalars['Float']['output']>;
  reportedTransacted2pOilCondensateReservesMmbbl?: Maybe<Scalars['Float']['output']>;
  reportedTransacted2pReservesMmboe?: Maybe<Scalars['Float']['output']>;
  sellSideAdvisor?: Maybe<Scalars['String']['output']>;
  sellerMotivation?: Maybe<Scalars['String']['output']>;
};

/** Input type for M&A deal details */
export type MaDealDetailsInput = {
  acreage?: InputMaybe<Scalars['Float']['input']>;
  announcementDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  buySideAdvisor?: InputMaybe<Scalars['String']['input']>;
  closingDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  dealStatus?: InputMaybe<MaDealStatusEnum>;
  paymentType?: InputMaybe<MaDealPaymentTypeEnum>;
  reportedAcreageAcquisitionCostUsdPerAcre?: InputMaybe<Scalars['Float']['input']>;
  reportedConsiderationBaseCashMmusd?: InputMaybe<Scalars['Float']['input']>;
  reportedConsiderationBaseEquityMmusd?: InputMaybe<Scalars['Float']['input']>;
  reportedConsiderationComment?: InputMaybe<Scalars['String']['input']>;
  reportedConsiderationContingentMmusd?: InputMaybe<Scalars['Float']['input']>;
  reportedConsiderationTotalMmusd?: InputMaybe<Scalars['Float']['input']>;
  reportedCostCarryMmusd?: InputMaybe<Scalars['Float']['input']>;
  reportedCostCommitmentMmusd?: InputMaybe<Scalars['Float']['input']>;
  reportedCurrentEmissionsIntensityKgco2ePerBoe?: InputMaybe<Scalars['Float']['input']>;
  reportedDebtMmusd?: InputMaybe<Scalars['Float']['input']>;
  reportedGasProductionMmcfd?: InputMaybe<Scalars['Float']['input']>;
  reportedOilCondensateProductionBbld?: InputMaybe<Scalars['Float']['input']>;
  reportedPricePerFlowingBarrelUsdPerBoed?: InputMaybe<Scalars['Float']['input']>;
  reportedProductionBoed?: InputMaybe<Scalars['Float']['input']>;
  reportedRemainingEmissionsIntensityKgco2ePerBoe?: InputMaybe<Scalars['Float']['input']>;
  reportedReservesAcquisitionCostUsdPerBoe?: InputMaybe<Scalars['Float']['input']>;
  reportedSignatureBonusMmusd?: InputMaybe<Scalars['Float']['input']>;
  reportedTransacted1pGasReservesBcf?: InputMaybe<Scalars['Float']['input']>;
  reportedTransacted1pOilCondensateReservesMmbbl?: InputMaybe<Scalars['Float']['input']>;
  reportedTransacted1pReservesMmboe?: InputMaybe<Scalars['Float']['input']>;
  reportedTransacted2cGasResourceBcf?: InputMaybe<Scalars['Float']['input']>;
  reportedTransacted2cOilCondensateResourceMmbbl?: InputMaybe<Scalars['Float']['input']>;
  reportedTransacted2cResourceMmboe?: InputMaybe<Scalars['Float']['input']>;
  reportedTransacted2pGasReservesBcf?: InputMaybe<Scalars['Float']['input']>;
  reportedTransacted2pOilCondensateReservesMmbbl?: InputMaybe<Scalars['Float']['input']>;
  reportedTransacted2pReservesMmboe?: InputMaybe<Scalars['Float']['input']>;
  sellSideAdvisor?: InputMaybe<Scalars['String']['input']>;
  sellerMotivation?: InputMaybe<Scalars['String']['input']>;
};

export enum MaDealPaymentTypeEnum {
  /** Cash payment type for deal */
  Cash = 'CASH',
  /** Cost carry payment type for deal */
  CostCarry = 'COST_CARRY',
  /** Debt payment type for deal */
  Debt = 'DEBT',
  /** Equity payment type for deal */
  Equity = 'EQUITY',
  /** Mix payment type for deal */
  Mix = 'MIX'
}

export enum MaDealStatusEnum {
  /** Closed status */
  Closed = 'CLOSED',
  /** Failed status */
  Failed = 'FAILED',
  /** Ongoing status */
  Ongoing = 'ONGOING'
}

export type MaDealType = {
  __typename?: 'MaDealType';
  group: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type MaDealsQuery = {
  __typename?: 'MaDealsQuery';
  deals: Array<MaDeal>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type MaFilters = {
  assets?: InputMaybe<Array<Scalars['Int']['input']>>;
  basins?: InputMaybe<Array<Scalars['Int']['input']>>;
  blocks?: InputMaybe<Array<Scalars['Int']['input']>>;
  buyers?: InputMaybe<Array<Scalars['Int']['input']>>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  deals?: InputMaybe<Array<Scalars['Int']['input']>>;
  developmentStatuses?: InputMaybe<Array<Scalars['Int']['input']>>;
  endYear?: InputMaybe<Scalars['Int']['input']>;
  eventTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  fields?: InputMaybe<Array<Scalars['Int']['input']>>;
  hasBuyers?: InputMaybe<Scalars['Boolean']['input']>;
  hasSellers?: InputMaybe<Scalars['Boolean']['input']>;
  hydrocarbonTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  includeNegativeValuations?: InputMaybe<Scalars['Boolean']['input']>;
  maxAcquisitionCost?: InputMaybe<Scalars['Float']['input']>;
  maxEmissions?: InputMaybe<Scalars['Int']['input']>;
  maxPriceFlowingBarrel?: InputMaybe<Scalars['Float']['input']>;
  maxProduction?: InputMaybe<Scalars['Int']['input']>;
  maxReserves?: InputMaybe<Scalars['Int']['input']>;
  maxValuation?: InputMaybe<Scalars['Int']['input']>;
  minAcquisitionCost?: InputMaybe<Scalars['Float']['input']>;
  minEmissions?: InputMaybe<Scalars['Int']['input']>;
  minPriceFlowingBarrel?: InputMaybe<Scalars['Float']['input']>;
  minProduction?: InputMaybe<Scalars['Int']['input']>;
  minReserves?: InputMaybe<Scalars['Int']['input']>;
  minValuation?: InputMaybe<Scalars['Int']['input']>;
  oilTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  sellers?: InputMaybe<Array<Scalars['Int']['input']>>;
  shoreStatuses?: InputMaybe<Array<Scalars['Int']['input']>>;
  startYear?: InputMaybe<Scalars['Int']['input']>;
};

export type MaOpportunitiesQuery = {
  __typename?: 'MaOpportunitiesQuery';
  opportunities: Array<MaOpportunity>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type MaOpportunitiesSummary = {
  __typename?: 'MaOpportunitiesSummary';
  count: Scalars['Int']['output'];
  maxEmissions: Scalars['Float']['output'];
  maxProduction: Scalars['Float']['output'];
  maxReserves: Scalars['Float']['output'];
  maxValuation: Scalars['Float']['output'];
  medianCapex: Scalars['Float']['output'];
  medianProduction: Scalars['Float']['output'];
  medianReserves: Scalars['Float']['output'];
  medianValuation: Scalars['Float']['output'];
  minEmissions: Scalars['Float']['output'];
  minProduction: Scalars['Float']['output'];
  minReserves: Scalars['Float']['output'];
  minValuation: Scalars['Float']['output'];
};

export type MaOpportunity = {
  __typename?: 'MaOpportunity';
  asset?: Maybe<Asset>;
  assetId: Scalars['Int']['output'];
  assetName?: Maybe<Scalars['String']['output']>;
  assetUuid: Scalars['String']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  country: Country;
  countryId: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  dateOfEntry?: Maybe<Scalars['ISO8601Date']['output']>;
  estimatedRecentProduction?: Maybe<Scalars['Float']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  npv?: Maybe<Scalars['Float']['output']>;
  officiallyOnMarket?: Maybe<Scalars['String']['output']>;
  operatedStake?: Maybe<Scalars['Boolean']['output']>;
  pricePerFlowingBarrel?: Maybe<Scalars['Float']['output']>;
  remainingCapex?: Maybe<Scalars['Float']['output']>;
  remainingGasReserves?: Maybe<Scalars['Float']['output']>;
  remainingLiquidReserves?: Maybe<Scalars['Float']['output']>;
  remainingReserves?: Maybe<Scalars['Float']['output']>;
  resourceTheme?: Maybe<Scalars['String']['output']>;
  sellerCompany?: Maybe<Company>;
  sellerCompanyId: Scalars['Int']['output'];
  sellerCompanyName?: Maybe<Scalars['String']['output']>;
  sellerMotivation?: Maybe<Scalars['String']['output']>;
  sellerStake?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export enum MaStackByEnum {
  Asset = 'asset',
  Buyer = 'buyer',
  Seller = 'seller',
  Type = 'type'
}

export type MaTransactionQuery = {
  __typename?: 'MaTransactionQuery';
  totalCount?: Maybe<Scalars['Int']['output']>;
  transactions: Array<MaAssetTransaction>;
};

export type MaTransactionsSummary = {
  __typename?: 'MaTransactionsSummary';
  endYear: Scalars['Int']['output'];
  maxAcquisitionCostOutliers: Scalars['Float']['output'];
  maxEmissions: Scalars['Float']['output'];
  maxPriceFlowingBarrelOutliers: Scalars['Float']['output'];
  maxProduction: Scalars['Float']['output'];
  maxReserves: Scalars['Float']['output'];
  maxValuation: Scalars['Float']['output'];
  medianProductionAcquisitionCost: Scalars['Float']['output'];
  medianReserves: Scalars['Float']['output'];
  medianReservesAcquisitionCost: Scalars['Float']['output'];
  medianValuation: Scalars['Float']['output'];
  minAcquisitionCostOutliers: Scalars['Float']['output'];
  minEmissions: Scalars['Float']['output'];
  minPriceFlowingBarrelOutliers: Scalars['Float']['output'];
  minProduction: Scalars['Float']['output'];
  minReserves: Scalars['Float']['output'];
  minValuation: Scalars['Float']['output'];
  numDeals: Scalars['Int']['output'];
  numTransactions: Scalars['Int']['output'];
  startYear: Scalars['Int']['output'];
};

export type ManualEntityNameMapping = {
  __typename?: 'ManualEntityNameMapping';
  author?: Maybe<Scalars['String']['output']>;
  dirtyEntityName?: Maybe<Scalars['String']['output']>;
  entityName?: Maybe<EntityName>;
  entityNameId?: Maybe<Scalars['ID']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ManualReviewEntities = {
  __typename?: 'ManualReviewEntities';
  manualReviewEntities: Array<ManualReviewEntity>;
  totalCount: Scalars['Int']['output'];
};

export type ManualReviewEntity = {
  __typename?: 'ManualReviewEntity';
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  entityNameSuggestions?: Maybe<Array<EntityName>>;
  entityType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  manualEntityNameMapping?: Maybe<ManualEntityNameMapping>;
  tentativeEntityName?: Maybe<Scalars['String']['output']>;
};

export type MapFeature = {
  __typename?: 'MapFeature';
  data: Scalars['JSON']['output'];
  feature: Scalars['JSON']['output'];
  layer: Scalars['String']['output'];
};

export type MapScreening = {
  __typename?: 'MapScreening';
  country: Country;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currentParticipations?: Maybe<Array<Participation>>;
  displayName?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  geom?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  legacyId?: Maybe<Scalars['ID']['output']>;
  multiPolygon: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  operator?: Maybe<Company>;
  participations?: Maybe<Array<Participation>>;
  sectionGeomCoordinates?: Maybe<Array<Scalars['JSON']['output']>>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type MapboxConfig = {
  __typename?: 'MapboxConfig';
  mapboxSourceUrl?: Maybe<Scalars['String']['output']>;
  mapboxToken?: Maybe<Scalars['String']['output']>;
};

export type ModelInputsAssetItem = {
  __typename?: 'ModelInputsAssetItem';
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  validation?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ModelInputsAssets = {
  __typename?: 'ModelInputsAssets';
  items: Array<ModelInputsAssetItem>;
};

export type ModelInputsUpdateResponse = {
  __typename?: 'ModelInputsUpdateResponse';
  message?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addToWatchList?: Maybe<AddToWatchListMutationPayload>;
  /** Creates a new cashflow template with the provided details */
  createCashflowTemplate?: Maybe<CreateCashflowTemplateMutationPayload>;
  createChatMessage?: Maybe<ChatMessage>;
  createChatSession?: Maybe<ChatSession>;
  /** Creates a new GIS File with the provided details */
  createGisFile?: Maybe<CreateGisFileMutationPayload>;
  createGisFileUploadUrl?: Maybe<CreateGisFileUploadUrlMutationPayload>;
  /** Create Hubspot Ticket */
  createHubspotTicket?: Maybe<CreateHubspotTicketMutationPayload>;
  /** Creates a presigned URL for uploading a template file to S3 */
  createPresignedS3Url?: Maybe<CreatePresignedS3UrlMutationPayload>;
  createSmartReport?: Maybe<SmartReport>;
  createSmartReportVersion?: Maybe<SmartReport>;
  createUserFilter?: Maybe<CreateUserFilterMutationPayload>;
  createUserPortfolio?: Maybe<CreateUserPortfolioMutationPayload>;
  createUserPortfolioFilter?: Maybe<CreateUserPortfolioFilterMutationPayload>;
  createUserPriceDeck?: Maybe<CreateUserPriceDeckMutationPayload>;
  deleteUserFilter?: Maybe<DeleteUserFilterMutationPayload>;
  /** Aborts an ongoing data ingestion process */
  ditAbortEvent?: Maybe<AbortEvent>;
  /** Creates a new event in the data ingestion tool for a specific country and source */
  ditCreateEvent?: Maybe<CreateEvent>;
  /** Starts the data ingestion process for a specific event */
  ditStartIngestion?: Maybe<Scalars['Boolean']['output']>;
  getGisFileDownloadUrl?: Maybe<GetGisFileDownloadUrlMutationPayload>;
  nexusCreateCompany?: Maybe<CreateCompanyMutationPayload>;
  nexusCreateManualEntityNameMapping?: Maybe<CreateManualEntityNameMappingMutationPayload>;
  /** Update model inputs for specific asset and group */
  nexusUpdateModelInputsAssets?: Maybe<ModelInputsUpdateResponse>;
  oAuth2Login?: Maybe<OAuth2LoginPayload>;
  /** Publishes a cashflow template */
  publishCashflowTemplate?: Maybe<PublishCashflowTemplateMutationPayload>;
  publishGisFile?: Maybe<PublishGisFileMutationPayload>;
  publishSmartReportVersion?: Maybe<SmartReport>;
  removeFromWatchList?: Maybe<RemoveFromWatchListMutationPayload>;
  seenNewFeature?: Maybe<SeenNewFeatureMutationPayload>;
  seenUserWelcome?: Maybe<SeenUserWelcomeMutationPayload>;
  shareUserFilter?: Maybe<ShareUserFilterMutationPayload>;
  shareUserPortfolio?: Maybe<ShareUserPortfolioMutationPayload>;
  /** Create or update M&A deal details for a given deal id. */
  updateMaDealDetails?: Maybe<MaDealDetails>;
  updateMe?: Maybe<UpdateMeMutationPayload>;
  updateSmartReport?: Maybe<SmartReport>;
  updateSmartReportVersion?: Maybe<SmartReportVersion>;
  updateUserFilter?: Maybe<UpdateUserFilterMutationPayload>;
  userConfirmRegistrationWithToken?: Maybe<UserConfirmRegistrationWithTokenPayload>;
  userLogin?: Maybe<LoginPayload>;
  userLogout?: Maybe<UserLogoutPayload>;
  userRegister?: Maybe<RegisterPayload>;
  userResendConfirmationWithToken?: Maybe<UserResendConfirmationWithTokenPayload>;
  userSendPasswordResetWithToken?: Maybe<UserSendPasswordResetWithTokenPayload>;
  userUpdatePasswordWithToken?: Maybe<UserUpdatePasswordWithTokenPayload>;
};


export type MutationAddToWatchListArgs = {
  assetIsoCode: Scalars['String']['input'];
  assetLegacyId: Scalars['ID']['input'];
};


export type MutationCreateCashflowTemplateArgs = {
  input: CreateCashflowTemplateInput;
};


export type MutationCreateChatMessageArgs = {
  chatSessionId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
};


export type MutationCreateGisFileArgs = {
  countryId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  regionId?: InputMaybe<Scalars['ID']['input']>;
  s3Bucket: Scalars['String']['input'];
  s3Key: Scalars['String']['input'];
  uuid: Scalars['ID']['input'];
};


export type MutationCreateGisFileUploadUrlArgs = {
  filename: Scalars['String']['input'];
};


export type MutationCreateHubspotTicketArgs = {
  description: Scalars['String']['input'];
  issueType: Scalars['String']['input'];
  summary: Scalars['String']['input'];
};


export type MutationCreatePresignedS3UrlArgs = {
  modelType: Scalars['String']['input'];
};


export type MutationCreateSmartReportArgs = {
  input: SmartReportCreateInput;
};


export type MutationCreateSmartReportVersionArgs = {
  reportId: Scalars['ID']['input'];
};


export type MutationCreateUserFilterArgs = {
  filter: Scalars['JSON']['input'];
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type MutationCreateUserPortfolioArgs = {
  context: Scalars['String']['input'];
  name: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  portfolio: Scalars['JSON']['input'];
};


export type MutationCreateUserPortfolioFilterArgs = {
  assets?: InputMaybe<Array<Scalars['JSON']['input']>>;
  basins?: InputMaybe<Array<Scalars['JSON']['input']>>;
  companies?: InputMaybe<Array<Scalars['JSON']['input']>>;
  countries?: InputMaybe<Array<Scalars['JSON']['input']>>;
  developmentStatuses?: InputMaybe<Array<Scalars['JSON']['input']>>;
  npvMax?: InputMaybe<Scalars['Float']['input']>;
  npvMin?: InputMaybe<Scalars['Float']['input']>;
  operator?: InputMaybe<Scalars['Boolean']['input']>;
  opportunities?: InputMaybe<Scalars['Boolean']['input']>;
  productionMax?: InputMaybe<Scalars['Float']['input']>;
  productionMin?: InputMaybe<Scalars['Float']['input']>;
  reservesMax?: InputMaybe<Scalars['Float']['input']>;
  reservesMin?: InputMaybe<Scalars['Float']['input']>;
  resourceThemes?: InputMaybe<Array<Scalars['JSON']['input']>>;
  shoreStatuses?: InputMaybe<Array<Scalars['JSON']['input']>>;
};


export type MutationCreateUserPriceDeckArgs = {
  name: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  priceDeck: Scalars['JSON']['input'];
};


export type MutationDeleteUserFilterArgs = {
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type MutationDitAbortEventArgs = {
  eventId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
};


export type MutationDitCreateEventArgs = {
  countryIsoCode: Scalars['String']['input'];
  sourceFiles: Array<SourceFileInput>;
  sourceId: Scalars['ID']['input'];
};


export type MutationDitStartIngestionArgs = {
  eventId: Scalars['ID']['input'];
};


export type MutationGetGisFileDownloadUrlArgs = {
  id: Scalars['ID']['input'];
};


export type MutationNexusCreateCompanyArgs = {
  companyName: Scalars['String']['input'];
  manualReviewEntityId: Scalars['ID']['input'];
};


export type MutationNexusCreateManualEntityNameMappingArgs = {
  entityNameId: Scalars['ID']['input'];
  manualReviewEntityId: Scalars['ID']['input'];
};


export type MutationNexusUpdateModelInputsAssetsArgs = {
  assetUuid: Scalars['String']['input'];
  group: Scalars['String']['input'];
  items: Array<Scalars['JSON']['input']>;
};


export type MutationOAuth2LoginArgs = {
  code: Scalars['String']['input'];
  provider: Scalars['String']['input'];
};


export type MutationPublishCashflowTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPublishGisFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPublishSmartReportVersionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveFromWatchListArgs = {
  assetIsoCode: Scalars['String']['input'];
  assetLegacyId: Scalars['ID']['input'];
};


export type MutationSeenNewFeatureArgs = {
  feature: Scalars['String']['input'];
};


export type MutationShareUserFilterArgs = {
  userFilterId: Scalars['ID']['input'];
  users: Array<Scalars['ID']['input']>;
};


export type MutationShareUserPortfolioArgs = {
  userPortfolioId: Scalars['ID']['input'];
  users: Array<Scalars['ID']['input']>;
};


export type MutationUpdateMaDealDetailsArgs = {
  dealId: Scalars['ID']['input'];
  input: MaDealDetailsInput;
};


export type MutationUpdateMeArgs = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  newPassword?: InputMaybe<Scalars['String']['input']>;
  newPasswordConf?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateSmartReportArgs = {
  id: Scalars['ID']['input'];
  input: SmartReportUpdateInput;
};


export type MutationUpdateSmartReportVersionArgs = {
  id: Scalars['ID']['input'];
  input: SmartReportVersionUpdateInput;
};


export type MutationUpdateUserFilterArgs = {
  filter: Scalars['JSON']['input'];
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};


export type MutationUserConfirmRegistrationWithTokenArgs = {
  confirmationToken: Scalars['String']['input'];
};


export type MutationUserLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationUserRegisterArgs = {
  city?: InputMaybe<Scalars['String']['input']>;
  confirmUrl?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  regionsOfInterest?: InputMaybe<Array<Scalars['String']['input']>>;
  token: Scalars['String']['input'];
  uid: Scalars['String']['input'];
};


export type MutationUserResendConfirmationWithTokenArgs = {
  confirmUrl: Scalars['String']['input'];
  email: Scalars['String']['input'];
};


export type MutationUserSendPasswordResetWithTokenArgs = {
  email: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
};


export type MutationUserUpdatePasswordWithTokenArgs = {
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
  resetPasswordToken: Scalars['String']['input'];
};

export type NexusCompany = {
  __typename?: 'NexusCompany';
  entityType: Scalars['String']['output'];
  entityUuid: Scalars['String']['output'];
  entityValidFrom: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  validFrom: Scalars['ISO8601DateTime']['output'];
};

export type NexusModelInputsConfig = {
  __typename?: 'NexusModelInputsConfig';
  items: Array<NexusModelInputsConfigItem>;
};

export type NexusModelInputsConfigItem = {
  __typename?: 'NexusModelInputsConfigItem';
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
};

export type Noop = {
  __typename?: 'Noop';
  message: Scalars['String']['output'];
};

/** Autogenerated return type of OAuth2Login. */
export type OAuth2LoginPayload = {
  __typename?: 'OAuth2LoginPayload';
  authenticatable?: Maybe<Authenticatable>;
  credentials?: Maybe<Credential>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

export type OAuth2Provider = {
  __typename?: 'OAuth2Provider';
  authUrl?: Maybe<Scalars['String']['output']>;
  clientId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  redirectUri?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
};

export type Object = {
  __typename?: 'Object';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  uuid?: Maybe<Scalars['ID']['output']>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Pagination and sorting input */
export type PaginationInput = {
  /** Sort order (asc or desc) */
  order?: InputMaybe<Scalars['String']['input']>;
  /** Field to sort by */
  orderBy?: InputMaybe<Scalars['String']['input']>;
  /** Page number */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Items per page */
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

export type Participation = {
  __typename?: 'Participation';
  comment?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  companyOperatorHistoricalNames?: Maybe<Scalars['JSON']['output']>;
  companyOperatorName?: Maybe<Scalars['String']['output']>;
  companyOperatorPercentStake?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  effectiveDate?: Maybe<Scalars['ISO8601Date']['output']>;
  eventType?: Maybe<Scalars['String']['output']>;
  formattedPercentStake?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isCompanyOperator?: Maybe<Scalars['Boolean']['output']>;
  mAndAOpportunity?: Maybe<Scalars['Boolean']['output']>;
  participationEntityType?: Maybe<Scalars['String']['output']>;
  partnerCompanies?: Maybe<Scalars['JSON']['output']>;
  percentStake?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ParticipationGrouped = {
  __typename?: 'ParticipationGrouped';
  comment?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  companyOperatorHistoricalNames?: Maybe<Scalars['JSON']['output']>;
  companyOperatorName?: Maybe<Scalars['String']['output']>;
  companyOperatorPercentStake?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  effectiveDate?: Maybe<Scalars['ISO8601Date']['output']>;
  eventType?: Maybe<Scalars['String']['output']>;
  formattedPercentStake?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isCompanyOperator?: Maybe<Scalars['Boolean']['output']>;
  mAndAOpportunity?: Maybe<Scalars['Boolean']['output']>;
  participationEntityType?: Maybe<Scalars['String']['output']>;
  partnerCompanies?: Maybe<Scalars['JSON']['output']>;
  percentStake?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ParticipationQuery = {
  __typename?: 'ParticipationQuery';
  participations: Array<ParticipationGrouped>;
  totalCount: Scalars['Int']['output'];
};

export type Pipeline = {
  __typename?: 'Pipeline';
  cost?: Maybe<Scalars['Float']['output']>;
  country: Country;
  createdAt: Scalars['ISO8601DateTime']['output'];
  destination?: Maybe<Scalars['String']['output']>;
  diameterInches?: Maybe<Scalars['Float']['output']>;
  formattedCost?: Maybe<Scalars['String']['output']>;
  formattedDiameterInches?: Maybe<Scalars['String']['output']>;
  formattedGasCapacityMmcfd?: Maybe<Scalars['String']['output']>;
  formattedLengthKm?: Maybe<Scalars['String']['output']>;
  formattedLiquidsCapacityBbld?: Maybe<Scalars['String']['output']>;
  gasCapacityMmcfd?: Maybe<Scalars['Float']['output']>;
  geom?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  isDisabled: Scalars['Boolean']['output'];
  legacyId: Scalars['ID']['output'];
  lengthKm?: Maybe<Scalars['Float']['output']>;
  liquidsCapacityBbld?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  network?: Maybe<Scalars['String']['output']>;
  operator?: Maybe<Scalars['String']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  participation?: Maybe<Scalars['String']['output']>;
  pipelineNetworks?: Maybe<Array<PipelineNetwork>>;
  product?: Maybe<PipelineProduct>;
  segment?: Maybe<Scalars['String']['output']>;
  shoreStatus?: Maybe<ShoreStatus>;
  sponsor?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status?: Maybe<PipelineStatus>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type PipelineNetwork = {
  __typename?: 'PipelineNetwork';
  aggregatedGeojson?: Maybe<Scalars['JSON']['output']>;
  assets?: Maybe<Array<Asset>>;
  capacity?: Maybe<Scalars['Float']['output']>;
  countries?: Maybe<Array<Country>>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  formattedCurrentCapacity?: Maybe<Scalars['String']['output']>;
  formattedDiameterInches?: Maybe<Scalars['String']['output']>;
  formattedHydrocarbon?: Maybe<Scalars['String']['output']>;
  formattedLengthKm?: Maybe<Scalars['String']['output']>;
  formattedStatus?: Maybe<Scalars['String']['output']>;
  geom?: Maybe<Scalars['JSON']['output']>;
  hasThroughputs: Scalars['Boolean']['output'];
  hydrocarbon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  operator?: Maybe<Scalars['String']['output']>;
  pipelines?: Maybe<Array<Pipeline>>;
  startUpYear?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type PipelineProduct = {
  __typename?: 'PipelineProduct';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type PipelineSegment = {
  __typename?: 'PipelineSegment';
  assets?: Maybe<Array<Asset>>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  destination?: Maybe<Scalars['String']['output']>;
  hasThroughputs: Scalars['Boolean']['output'];
  hydrocarbon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  legacyId: Scalars['ID']['output'];
  mostRecentPdp?: Maybe<Scalars['String']['output']>;
  mostRecentProductionDate?: Maybe<Scalars['ISO8601Date']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  pipeline?: Maybe<Pipeline>;
  pipelineSegmentThroughputs?: Maybe<PipelineSegmentThroughput>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type PipelineSegmentThroughput = {
  __typename?: 'PipelineSegmentThroughput';
  asset?: Maybe<Asset>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  gasPdpMmcfd?: Maybe<Scalars['Float']['output']>;
  gasUndevelopedMmcfd?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  liquidsPdpBbld?: Maybe<Scalars['Float']['output']>;
  liquidsUndevelopedBbld?: Maybe<Scalars['Float']['output']>;
  period?: Maybe<Scalars['ISO8601Date']['output']>;
  pipelineSegment?: Maybe<PipelineSegment>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type PipelineStatus = {
  __typename?: 'PipelineStatus';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type Portfolio = {
  assets?: InputMaybe<Array<Scalars['Int']['input']>>;
  basins?: InputMaybe<Array<Scalars['Int']['input']>>;
  companies?: InputMaybe<Array<Scalars['Int']['input']>>;
  countries?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** End date for data range (defaults to 9 years forward from current year) */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  productionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Start date for data range (defaults to 10 years back from current year) */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
};

export type PortfolioFilter = {
  __typename?: 'PortfolioFilter';
  assets?: Maybe<Array<Scalars['JSON']['output']>>;
  basins?: Maybe<Array<Scalars['JSON']['output']>>;
  companies?: Maybe<Array<Scalars['JSON']['output']>>;
  countries?: Maybe<Array<Scalars['JSON']['output']>>;
  developmentStatuses?: Maybe<Array<Scalars['JSON']['output']>>;
  npvMax?: Maybe<Scalars['Float']['output']>;
  npvMin?: Maybe<Scalars['Float']['output']>;
  operator?: Maybe<Scalars['Boolean']['output']>;
  opportunities?: Maybe<Scalars['Boolean']['output']>;
  productionMax?: Maybe<Scalars['Float']['output']>;
  productionMin?: Maybe<Scalars['Float']['output']>;
  reservesMax?: Maybe<Scalars['Float']['output']>;
  reservesMin?: Maybe<Scalars['Float']['output']>;
  resourceThemes?: Maybe<Array<Scalars['JSON']['output']>>;
  shoreStatuses?: Maybe<Array<Scalars['JSON']['output']>>;
};

export type PresaltPolygon = {
  __typename?: 'PresaltPolygon';
  country: Country;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  legacyId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Autogenerated return type of PublishCashflowTemplateMutation. */
export type PublishCashflowTemplateMutationPayload = {
  __typename?: 'PublishCashflowTemplateMutationPayload';
  errors: Array<Scalars['String']['output']>;
  template?: Maybe<CashflowTemplate>;
};

/** Autogenerated return type of PublishGisFileMutation. */
export type PublishGisFileMutationPayload = {
  __typename?: 'PublishGisFileMutationPayload';
  errors: Array<Scalars['String']['output']>;
  gisFile?: Maybe<GisFile>;
};

export type Query = {
  __typename?: 'Query';
  /** Get asset */
  asset?: Maybe<Asset>;
  /** Returns asset metric aggregates to be used in smart reports components */
  assetAggregates: Array<AssetAggregates>;
  /** Returns asset metric aggregates to be used in smart reports stacked charts */
  assetAggregatesStacked: AssetAggregatesStacked;
  /** Return production data by year for asset production table component */
  assetProductionTable: Array<AssetProductionTable>;
  /** Get asset by ID or UUID */
  assetV2?: Maybe<Asset>;
  /** List assets */
  assets: AssetsConnection;
  /** List assets that match search param with country dependency */
  assetsByNameAndCountry: Array<Asset>;
  /** List assets that match search param with filter dependency */
  assetsByNameWithFilter: AssetQuery;
  /** List assets that match search key param */
  assetsBySearchKey: Array<Asset>;
  /** List assets */
  assetsConnection: AssetsConnection;
  /** List assets that match the filters */
  assetsFilter: Array<Asset>;
  /** Get a presigned url link to download a file */
  availableCountryDownloads: AvailableDownloads;
  /** Get storage site */
  availableModelDownload: AvailableModelDownload;
  /** Get basin */
  basin: Basin;
  /** List basins */
  basins: Array<Basin>;
  /** List basins with filter dependency */
  basinsWithFilter: BasinQuery;
  /** List basins with filter dependency for map related views */
  basinsWithMapFilter: Array<Basin>;
  /** Get block */
  block: Block;
  /** List blocks */
  blocks: Array<Block>;
  /** List blocks and leases that match search param with country dependency for map filter */
  blocksAndLeasesByNameAndCountry: Array<Block>;
  /** List blocks that match search param with country dependency for map filter */
  blocksByNameAndCountry: Array<Block>;
  /** Returns all cashflow templates */
  cashflowTemplates: CashflowTemplatesQuery;
  /** List subscribed CCUS countries with filter dependency */
  ccusCountries: Array<Country>;
  /** Get ccus project */
  ccusProject: DimCcusProject;
  /** List chat session messages */
  chatSessionMessages: Array<ChatMessage>;
  chatSessions: ChatSessionsQuery;
  /** Get ccus facility */
  co2Emitter: DimFacilityDownload;
  /** List companies */
  companies: Array<Company>;
  /** List companies */
  companiesWithAssets: Array<Company>;
  /** List companies with filter dependency - only asset participants */
  companiesWithFilter: CompanyQuery;
  /** List companies with filter dependency for map related views */
  companiesWithMapFilter: CompanyQuery;
  /** Fetch a company by ID */
  company: Company;
  /** Runs ConsolidatedCashflowsWorker */
  consolidatedAssetCashflows: ConsolidatedAssetCashflow;
  /** Get the status of a consolidated asset cashflows report request */
  consolidatedAssetCashflowsRequestStatus?: Maybe<ConsolidatedAssetCashflowsRequestStatus>;
  /** Fetches Consolidated Asset Cashflows template types */
  consolidatedAssetCashflowsTemplateTypes: Array<ConsolidatedAssetCashflowsTemplate>;
  /** List user Consolidated Asset Cashflows reports */
  consolidatedAssetCashflowsUserReports: Array<ConsolidatedAssetCashflowsUserReports>;
  /** Return assets data for the consolidated cashflows */
  consolidatedAssets: ConsolidatedAssets;
  /** List countries */
  countries: Array<Country>;
  /** List subscribed countries with filter dependency */
  countriesWithFilter: Array<Country>;
  /** List subscribed countries with filter dependency for map related views */
  countriesWithMapFilter: Array<Country>;
  /** Get country by ID or UUID */
  country?: Maybe<Country>;
  /** Get country statistics for the filtered countries */
  countryStatistics: Array<Country>;
  /** Get users from the current user's client */
  currentUserFriends?: Maybe<Array<User>>;
  /** Get the currently authenticated user */
  currentUserProfile?: Maybe<CurrentUserProfile>;
  /** List records that match filter param */
  dataDownloads?: Maybe<DataDownload>;
  /** List records that match filter param */
  dataDownloadsMetaData?: Maybe<DataDownload>;
  /** List all development status */
  developmentStatus: Array<DevelopmentStatus>;
  /** List develop status with country filter dependency */
  developmentStatusWithFilter: Array<DevelopmentStatus>;
  /** List all development types */
  developmentType: Array<DevelopmentType>;
  /** List all dimension development statuses */
  dimCcusDevelopmentStatus: Array<DimCcusDevelopmentStatus>;
  /** List all dimension project scales */
  dimCcusProjectScale: Array<DimCcusProjectScale>;
  /** List all dimension project types */
  dimCcusProjectType: Array<DimCcusProjectType>;
  /** List dimension storage sites */
  dimCcusProjects: DimCcusProjectQuery;
  /** List all dimension separation types */
  dimCcusSeparationType: Array<DimCcusSeparationType>;
  /** List dimension companies with filter dependency */
  dimCompaniesWithFilter: DimCompanyQuery;
  /** List all dimension company targets */
  dimCompanyTarget: Array<DimCompanyTarget>;
  /** List dimension facilities */
  dimFacilities: DimFacilityQuery;
  /** List all industries */
  dimIndustry: Array<DimIndustry>;
  /** List all dimension shore statuses */
  dimShoreStatus: Array<DimShoreStatus>;
  /** List all dimension storage block statuses */
  dimStorageBlockStatus: Array<DimStorageBlockStatus>;
  /** List dimension storage sites */
  dimStorageSites: DimStorageSiteQuery;
  /** List all dimension storage types */
  dimStorageType: Array<DimStorageType>;
  /** Returns all available countries for data ingestion tool */
  ditCountries: Array<DitCountry>;
  /** Returns events for a specific country in the data ingestion tool */
  ditCountryEvents: Array<CountryEvent>;
  /** Downloads a file from S3 given the bucket and key */
  ditDownloadFile: Scalars['String']['output'];
  /** Returns the event details */
  ditEventDetails: CountryEvent;
  /** List user download history */
  downloadHistory: Array<DownloadHistory>;
  /** Get E&A well */
  eaWell: EaWell;
  /** List facilities */
  facilities: FacilityQuery;
  /** List facilities that match search param with country dependency */
  facilitiesByNameAndCountry: Array<Facility>;
  /** Get facility */
  facility: Facility;
  /** Return max values for the facility emission dataset */
  factFacilityEmissionMaxValues: FactFacilityEmissionMaxValues;
  /** Get feature flag values for the current user */
  featureFlags: Scalars['JSON']['output'];
  /** Get field */
  field: Field;
  /** Get field by ID or UUID */
  fieldV2?: Maybe<Field>;
  /** List fields */
  fields: Array<Field>;
  /** List fields that match search param with country dependency */
  fieldsByNameAndCountry: Array<Field>;
  /** List users watch list with filter options */
  filterWatchList: Array<Asset>;
  /** Get formation */
  formation: Formation;
  /** Fulltext reports search query */
  fulltextReportsSearch?: Maybe<Array<FulltextReportsSearchResult>>;
  /** Fulltext search query */
  fulltextSearch?: Maybe<Array<FulltextSearchResult>>;
  /** List geologies with filter dependency */
  geologiesWithFilter: Array<Geology>;
  /** List epochs */
  geologyEpochs: Array<GeologyEpoch>;
  /** Get ghg filters (asset, company, basin) */
  ghgFilter: GhgFilter;
  gisFiles: GisFilesResponse;
  /** Return global assumptions */
  globalAssumptions: GlobalAssumptions;
  /** Return analytics data in line graph ready format */
  graphAnalytics: Analytics;
  /** Return assets data in graph ready format */
  graphAssetsNew: Analytics;
  /** Return ccus data in graph ready format */
  graphCcus: Analytics;
  /** Get a facilities productions in dygraph format */
  graphFacilityProductions: GraphFacilityProduction;
  /** Get pipeline network throughputs in dygraph format */
  graphPipelineNetworkThroughputs: GraphPipelineNetworkThroughput;
  /** Get a pipeline throughput by asset view in dygraph format */
  graphPipelineThroughputAssetView: GraphPipelineThroughput;
  /** Get a pipeline throughput in dygraph format */
  graphPipelineThroughputs: GraphPipelineThroughput;
  /** Get a list of industry tracker download types. */
  industryTrackerDownloadTypes: Array<IndustryTracker>;
  /** Get lead analyst */
  leadAnalyst: LeadAnalyst;
  /** Get lease */
  lease: Lease;
  /** List lithologies */
  lithologies: Array<Lithology>;
  /** Get LNG liquefaction facility */
  lngLiquefaction: LngLiquefaction;
  /** Get LNG project */
  lngProject: LngProject;
  /** List LNG projects that match search param with country dependency */
  lngProjectsByNameAndCountry: Array<LngProject>;
  /** Get LNG regas facility */
  lngRegas: LngRegas;
  /** List users price decks */
  loadPriceDecks: LoadPriceDecks;
  /** List assets that match search param with filter dependency and appear in the M&A deals page. */
  maAssetsByNameWithFilter: MaAssetQuery;
  /** Return M&A deal details data. */
  maDeal: MaDeal;
  /** List all types in present in the M&A Deals table. */
  maDealTypes: Array<MaDealType>;
  /** Return M&A deals data, along with aggregated metrics of associated company and assets transactions. */
  maDeals: MaDealsQuery;
  /** Return M&A opportunities data, along with respective companies */
  maOpportunities: MaOpportunitiesQuery;
  /** Get M&A opportunities metrics aggregated by given variable (i.e. countries, buyers, sellers, year) */
  maOpportunitiesAggregates: Array<MaAggregates>;
  /**
   * Get M&A opportunity metrics aggregated by given variable (i.e. countries, sellers, year),
   * stacked by the seller company.
   */
  maOpportunitiesAggregatesStacked: MaAggregatesStacked;
  /** Get M&A opportunities summary */
  maOpportunitiesSummary: MaOpportunitiesSummary;
  /** Return M&A asset transactions data, along with respective companies and deals */
  maTransactions: MaTransactionQuery;
  /** Get M&A transaction metrics aggregated by given variable (i.e. countries, buyers, sellers, year) */
  maTransactionsAggregates: Array<MaAggregates>;
  /**
   * Get M&A transaction metrics aggregated by given variable (i.e. countries, buyers, sellers, year),
   * stacked by either the buyer or seller company.
   */
  maTransactionsAggregatesStacked: MaAggregatesStacked;
  /** Get M&A transaction metrics summary */
  maTransactionsSummary: MaTransactionsSummary;
  /** Return company data in map ready format */
  mapCompanies: MapFeature;
  /** Return user clickable countries in map ready format */
  mapInteractiveCountries: MapFeature;
  /** Return company data in map ready format */
  mapNpv: MapFeature;
  /** Return production data in map ready format */
  mapProduction: MapFeature;
  /** Return reserves data in map ready format */
  mapReserves: MapFeature;
  /** Screen assets for map */
  mapScreening: Array<MapScreening>;
  /** Screen E&A wells for map */
  mapScreeningEaWells: Array<EaWell>;
  /** Get Mapbox configuration details */
  mapboxConfig: MapboxConfig;
  /** Get a job by ID */
  nexusJob: Job;
  /** Get a list of jobs */
  nexusJobs: Array<Job>;
  /** Get available filter options for jobs */
  nexusJobsFilters: JobsFilters;
  /** Get a list of manual review entities */
  nexusManualReviewEntities: ManualReviewEntities;
  /** Get a manual review entity */
  nexusManualReviewEntity: ManualReviewEntity;
  /** Get model inputs for specific asset and group */
  nexusModelInputsAssets: ModelInputsAssets;
  /** Get model inputs configuration */
  nexusModelInputsConfig: NexusModelInputsConfig;
  /** Noop query */
  noop: Noop;
  /** Get list of available OAuth2 providers */
  oAuth2Providers: Array<OAuth2Provider>;
  /** List participations for given entity type (Asset/Block/Field). */
  participations: ParticipationQuery;
  /** Get pipeline */
  pipeline: Pipeline;
  /** Get pipeline network */
  pipelineNetwork: PipelineNetwork;
  /** List pipeline networks that match search param with country dependency */
  pipelineNetworksByNameAndCountry: Array<PipelineNetwork>;
  /** Get pipeline segment */
  pipelineSegment: PipelineSegment;
  /** Get a presalt polygon */
  presaltPolygon: PresaltPolygon;
  /** Returns the published cashflow template for the given country iso codes */
  publishedCashflowTemplate?: Maybe<CashflowTemplate>;
  /** List regions */
  regions: Array<Region>;
  /** List all resource types */
  resourceType: Array<ResourceType>;
  /** Get a restricted area */
  restrictedArea: RestrictedArea;
  /** Search filter items */
  searchFilterItems: Array<SearchFilterItem>;
  /** Get a presigned url link to download a file */
  secureCcusDownload: SecureDownload;
  /** Get a presigned url link to download a file */
  secureCountryDownload: SecureDownload;
  /** Get a presigned url link to download a file */
  secureRegionDownload: SecureDownload;
  /** Get a presigned url link to download a file */
  secureReportDownload: SecureDownload;
  /** Get a presigned url link to download a file */
  secureSubscriberDownload: SecureDownload;
  /** Prepare Shiny URLs */
  shinyUrl: SecureDownload;
  /** List all shore status */
  shoreStatus: Array<ShoreStatus>;
  smartReport?: Maybe<SmartReport>;
  /** List smart report templates */
  smartReportTemplates: SmartReportTemplatesQuery;
  /** Returns all available smart report types */
  smartReportTypes: Array<SmartReport>;
  /** List all smart reports with pagination and sorting */
  smartReportsList: SmartReportQuery;
  /** Get storage site */
  storageSite: DimStorageSiteDownload;
  /** Confirm a user token for registration */
  userConfirmation: UserConfirmation;
  /** List users filters */
  userFilters: Array<UserFilter>;
  /** Fetch a user's portfolio filter by UUID */
  userPortfolioFilter: UserPortfolioFilter;
  /** List users portfolios */
  userPortfolios: LoadPortfolio;
  /** Return a list of videos with filters */
  videos: VideoQuery;
  /** List users watch list */
  watchList: Array<Asset>;
  /** Get well */
  well?: Maybe<Well>;
  /** Get well by ID or UUID */
  wellV2?: Maybe<Well>;
  /** List wells */
  wells: Array<Well>;
  /** List wells that match search param with country dependency */
  wellsByNameAndCountry: Array<Well>;
};


export type QueryAssetArgs = {
  countryIsoCode: Scalars['String']['input'];
  feature?: InputMaybe<Scalars['String']['input']>;
  legacyId: Scalars['ID']['input'];
};


export type QueryAssetAggregatesArgs = {
  input?: InputMaybe<AssetAggregatesInput>;
};


export type QueryAssetAggregatesStackedArgs = {
  input?: InputMaybe<AssetAggregatesInput>;
};


export type QueryAssetProductionTableArgs = {
  input: AssetProductionTableInput;
};


export type QueryAssetV2Args = {
  input: EntityIdentifierInput;
};


export type QueryAssetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assetIsoCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  assetLegacyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  basin?: InputMaybe<Array<Scalars['String']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  companiesByAndOperator?: InputMaybe<Scalars['Boolean']['input']>;
  company?: InputMaybe<Array<Scalars['String']['input']>>;
  country?: InputMaybe<Array<Scalars['String']['input']>>;
  depthMax?: InputMaybe<Scalars['Float']['input']>;
  depthMin?: InputMaybe<Scalars['Float']['input']>;
  developmentStatus?: InputMaybe<Array<Scalars['ID']['input']>>;
  developmentType?: InputMaybe<Array<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  geologyEpochIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  hydrocarbonType?: InputMaybe<Array<Scalars['String']['input']>>;
  includeHistoricalParticipants?: InputMaybe<Scalars['Boolean']['input']>;
  isWalkthrough?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nonOperator?: InputMaybe<Scalars['Boolean']['input']>;
  npvMax?: InputMaybe<Scalars['Float']['input']>;
  npvMin?: InputMaybe<Scalars['Float']['input']>;
  oilType?: InputMaybe<Array<Scalars['String']['input']>>;
  operator?: InputMaybe<Scalars['Boolean']['input']>;
  opportunities?: InputMaybe<Scalars['Boolean']['input']>;
  productionMax?: InputMaybe<Scalars['Float']['input']>;
  productionMin?: InputMaybe<Scalars['Float']['input']>;
  reservesMax?: InputMaybe<Scalars['Float']['input']>;
  reservesMin?: InputMaybe<Scalars['Float']['input']>;
  shoreStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  sortAscending: Scalars['Boolean']['input'];
  sortType: Scalars['String']['input'];
};


export type QueryAssetsByNameAndCountryArgs = {
  country?: InputMaybe<Scalars['ID']['input']>;
  feature?: InputMaybe<Scalars['String']['input']>;
  search: Scalars['String']['input'];
};


export type QueryAssetsByNameWithFilterArgs = {
  basins?: InputMaybe<Array<Scalars['String']['input']>>;
  companies?: InputMaybe<Array<Scalars['String']['input']>>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  feature?: InputMaybe<Scalars['String']['input']>;
  geologyEpochIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  includeHistoricalParticipants?: InputMaybe<Scalars['Boolean']['input']>;
  isMAndAOpportunity?: InputMaybe<Scalars['Boolean']['input']>;
  nonOperator?: InputMaybe<Scalars['Boolean']['input']>;
  operator?: InputMaybe<Scalars['Boolean']['input']>;
  search: Scalars['String']['input'];
};


export type QueryAssetsBySearchKeyArgs = {
  search: Array<Scalars['String']['input']>;
};


export type QueryAssetsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assetIsoCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  assetLegacyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  basin?: InputMaybe<Array<Scalars['String']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  companiesByAndOperator?: InputMaybe<Scalars['Boolean']['input']>;
  company?: InputMaybe<Array<Scalars['String']['input']>>;
  country?: InputMaybe<Array<Scalars['String']['input']>>;
  depthMax?: InputMaybe<Scalars['Float']['input']>;
  depthMin?: InputMaybe<Scalars['Float']['input']>;
  developmentStatus?: InputMaybe<Array<Scalars['ID']['input']>>;
  developmentType?: InputMaybe<Array<Scalars['ID']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  geologyEpochIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  hydrocarbonType?: InputMaybe<Array<Scalars['String']['input']>>;
  includeHistoricalParticipants?: InputMaybe<Scalars['Boolean']['input']>;
  isWalkthrough?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  nonOperator?: InputMaybe<Scalars['Boolean']['input']>;
  npvMax?: InputMaybe<Scalars['Float']['input']>;
  npvMin?: InputMaybe<Scalars['Float']['input']>;
  oilType?: InputMaybe<Array<Scalars['String']['input']>>;
  operator?: InputMaybe<Scalars['Boolean']['input']>;
  opportunities?: InputMaybe<Scalars['Boolean']['input']>;
  productionMax?: InputMaybe<Scalars['Float']['input']>;
  productionMin?: InputMaybe<Scalars['Float']['input']>;
  reservesMax?: InputMaybe<Scalars['Float']['input']>;
  reservesMin?: InputMaybe<Scalars['Float']['input']>;
  shoreStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  sortAscending: Scalars['Boolean']['input'];
  sortType: Scalars['String']['input'];
};


export type QueryAssetsFilterArgs = {
  assets?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryAvailableCountryDownloadsArgs = {
  countryIsoCode: Scalars['String']['input'];
};


export type QueryAvailableModelDownloadArgs = {
  entityType: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type QueryBasinArgs = {
  name: Scalars['String']['input'];
};


export type QueryBasinsWithFilterArgs = {
  assets?: InputMaybe<Array<Scalars['JSON']['input']>>;
  companies?: InputMaybe<Array<Scalars['String']['input']>>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  feature?: InputMaybe<Scalars['String']['input']>;
  hasMaTransactions?: InputMaybe<Scalars['Boolean']['input']>;
  isMAndAOpportunity?: InputMaybe<Scalars['Boolean']['input']>;
  nonOperator?: InputMaybe<Scalars['Boolean']['input']>;
  operator?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBasinsWithMapFilterArgs = {
  companies?: InputMaybe<Array<Scalars['String']['input']>>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  operator?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBlockArgs = {
  countryIsoCode: Scalars['String']['input'];
  feature?: InputMaybe<Scalars['String']['input']>;
  legacyId: Scalars['ID']['input'];
};


export type QueryBlocksAndLeasesByNameAndCountryArgs = {
  country?: InputMaybe<Scalars['ID']['input']>;
  feature?: InputMaybe<Scalars['String']['input']>;
  search: Scalars['String']['input'];
};


export type QueryBlocksByNameAndCountryArgs = {
  country?: InputMaybe<Scalars['ID']['input']>;
  feature?: InputMaybe<Scalars['String']['input']>;
  search: Scalars['String']['input'];
};


export type QueryCashflowTemplatesArgs = {
  input?: InputMaybe<CashflowTemplatesInput>;
};


export type QueryCcusCountriesArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryCcusProjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryChatSessionMessagesArgs = {
  chatSessionId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChatSessionsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryCo2EmitterArgs = {
  id: Scalars['ID']['input'];
  includeDownload?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCompaniesWithFilterArgs = {
  activeInBlocks?: InputMaybe<Scalars['Boolean']['input']>;
  activeInLeases?: InputMaybe<Scalars['Boolean']['input']>;
  assets?: InputMaybe<Array<Scalars['JSON']['input']>>;
  basins?: InputMaybe<Array<Scalars['String']['input']>>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  includeHistoricalParticipants?: InputMaybe<Scalars['Boolean']['input']>;
  isMAndAOpportunity?: InputMaybe<Scalars['Boolean']['input']>;
  maBuyers?: InputMaybe<Scalars['Boolean']['input']>;
  maSellers?: InputMaybe<Scalars['Boolean']['input']>;
  nonOperator?: InputMaybe<Scalars['Boolean']['input']>;
  operator?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCompaniesWithMapFilterArgs = {
  basins?: InputMaybe<Array<Scalars['String']['input']>>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  operator?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCompanyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryConsolidatedAssetCashflowsArgs = {
  assetIds: Array<Array<Scalars['ID']['input']>>;
  assetUnits: Array<Array<Scalars['JSON']['input']>>;
  basePrices?: InputMaybe<Scalars['JSON']['input']>;
  baseYear?: InputMaybe<Scalars['Int']['input']>;
  companyIds: Array<Array<Scalars['ID']['input']>>;
  companyNames?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  costInflation?: InputMaybe<Scalars['Float']['input']>;
  discountRate?: InputMaybe<Scalars['Int']['input']>;
  emailReport?: InputMaybe<Scalars['Boolean']['input']>;
  modelType?: InputMaybe<Scalars['String']['input']>;
  reportName?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  writeFlag?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryConsolidatedAssetCashflowsRequestStatusArgs = {
  requestId: Scalars['ID']['input'];
};


export type QueryConsolidatedAssetsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  portfolios?: InputMaybe<Array<Scalars['JSON']['input']>>;
};


export type QueryCountriesWithFilterArgs = {
  assets?: InputMaybe<Array<Scalars['JSON']['input']>>;
  basins?: InputMaybe<Array<Scalars['String']['input']>>;
  companies?: InputMaybe<Array<Scalars['String']['input']>>;
  feature?: InputMaybe<Scalars['String']['input']>;
  hasAssets?: InputMaybe<Scalars['Boolean']['input']>;
  hasBlocks?: InputMaybe<Scalars['Boolean']['input']>;
  hasGhgEmissions?: InputMaybe<Scalars['Boolean']['input']>;
  hasLeases?: InputMaybe<Scalars['Boolean']['input']>;
  hasMaTransactions?: InputMaybe<Scalars['Boolean']['input']>;
  hasNonModelledProduction?: InputMaybe<Scalars['Boolean']['input']>;
  includeHistoricalParticipants?: InputMaybe<Scalars['Boolean']['input']>;
  nonOperator?: InputMaybe<Scalars['Boolean']['input']>;
  operator?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCountriesWithMapFilterArgs = {
  basins?: InputMaybe<Array<Scalars['String']['input']>>;
  companies?: InputMaybe<Array<Scalars['String']['input']>>;
  operator?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCountryArgs = {
  input: EntityIdentifierInput;
};


export type QueryCountryStatisticsArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDataDownloadsArgs = {
  countryIsoCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  downloadType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDataDownloadsMetaDataArgs = {
  countryIsoCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  downloadType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDevelopmentStatusWithFilterArgs = {
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryDimCcusProjectsArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDimCompaniesWithFilterArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDimFacilitiesArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDimIndustryArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryDimStorageSitesArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDitCountryEventsArgs = {
  countryIsoCode: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  sourceFiles?: InputMaybe<Scalars['String']['input']>;
  sourceType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDitDownloadFileArgs = {
  s3Bucket: Scalars['String']['input'];
  s3FileKey: Scalars['String']['input'];
};


export type QueryDitEventDetailsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEaWellArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFacilitiesArgs = {
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
  feature?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFacilitiesByNameAndCountryArgs = {
  country?: InputMaybe<Scalars['ID']['input']>;
  feature?: InputMaybe<Scalars['String']['input']>;
  search: Scalars['String']['input'];
};


export type QueryFacilityArgs = {
  countryIsoCode: Scalars['String']['input'];
  feature?: InputMaybe<Scalars['String']['input']>;
  legacyId: Scalars['ID']['input'];
};


export type QueryFieldArgs = {
  countryIsoCode: Scalars['String']['input'];
  feature?: InputMaybe<Scalars['String']['input']>;
  legacyId: Scalars['ID']['input'];
};


export type QueryFieldV2Args = {
  input: EntityIdentifierInput;
};


export type QueryFieldsByNameAndCountryArgs = {
  country?: InputMaybe<Scalars['ID']['input']>;
  feature?: InputMaybe<Scalars['String']['input']>;
  search: Scalars['String']['input'];
};


export type QueryFilterWatchListArgs = {
  assetIsoCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  assetLegacyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  basin?: InputMaybe<Array<Scalars['String']['input']>>;
  company?: InputMaybe<Array<Scalars['String']['input']>>;
  country?: InputMaybe<Array<Scalars['String']['input']>>;
  depthMax?: InputMaybe<Scalars['Float']['input']>;
  depthMin?: InputMaybe<Scalars['Float']['input']>;
  developmentStatus?: InputMaybe<Array<Scalars['ID']['input']>>;
  developmentType?: InputMaybe<Array<Scalars['ID']['input']>>;
  geologyEpochIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  hydrocarbonType?: InputMaybe<Array<Scalars['String']['input']>>;
  includeHistoricalParticipants?: InputMaybe<Scalars['Boolean']['input']>;
  npvMax?: InputMaybe<Scalars['Float']['input']>;
  npvMin?: InputMaybe<Scalars['Float']['input']>;
  oilType?: InputMaybe<Array<Scalars['String']['input']>>;
  operator?: InputMaybe<Scalars['Boolean']['input']>;
  opportunities?: InputMaybe<Scalars['Boolean']['input']>;
  productionMax?: InputMaybe<Scalars['Float']['input']>;
  productionMin?: InputMaybe<Scalars['Float']['input']>;
  reservesMax?: InputMaybe<Scalars['Float']['input']>;
  reservesMin?: InputMaybe<Scalars['Float']['input']>;
  shoreStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  sortAscending: Scalars['Boolean']['input'];
  sortType: Scalars['String']['input'];
};


export type QueryFormationArgs = {
  countryIsoCode: Scalars['String']['input'];
  legacyId: Scalars['ID']['input'];
};


export type QueryFulltextReportsSearchArgs = {
  query: Scalars['String']['input'];
};


export type QueryFulltextSearchArgs = {
  filter: FulltextSearchFilterInput;
  query: Scalars['String']['input'];
};


export type QueryGeologiesWithFilterArgs = {
  assetIdentifiers?: InputMaybe<Array<FiltersAssetInput>>;
  countries?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryGhgFilterArgs = {
  assets?: InputMaybe<Array<Scalars['JSON']['input']>>;
  basins?: InputMaybe<Array<Scalars['JSON']['input']>>;
  companies?: InputMaybe<Array<Scalars['JSON']['input']>>;
  countries?: InputMaybe<Array<Scalars['JSON']['input']>>;
  filter: Scalars['String']['input'];
  includeHistoricalParticipants?: InputMaybe<Scalars['Boolean']['input']>;
  nonOperator?: InputMaybe<Scalars['Boolean']['input']>;
  operator?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGisFilesArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGraphAnalyticsArgs = {
  aggregate: Scalars['String']['input'];
  checkboxAggregates?: InputMaybe<Scalars['JSON']['input']>;
  discountRate?: InputMaybe<Scalars['Float']['input']>;
  emissionsSource?: InputMaybe<Array<Scalars['JSON']['input']>>;
  enableInfoOnClick?: InputMaybe<Scalars['Boolean']['input']>;
  graphType: Scalars['String']['input'];
  graphTypeOptions?: InputMaybe<Array<Scalars['String']['input']>>;
  hydrocarbonType?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  portfolios?: InputMaybe<Array<Scalars['JSON']['input']>>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  sortMetric?: InputMaybe<Scalars['String']['input']>;
  stacked?: InputMaybe<Scalars['Boolean']['input']>;
  visibleTraces?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGraphAssetsNewArgs = {
  aggregates: Array<Scalars['String']['input']>;
  chartType: Scalars['String']['input'];
  emissionsSource?: InputMaybe<Array<Scalars['JSON']['input']>>;
  enableInfoOnClick?: InputMaybe<Scalars['Boolean']['input']>;
  graphType: Scalars['String']['input'];
  graphTypeOptions?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  portfolios?: InputMaybe<Array<Scalars['JSON']['input']>>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  sortMetric?: InputMaybe<Scalars['String']['input']>;
  visibleTraces?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryGraphCcusArgs = {
  aggregate: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['JSON']['input']>;
  graphType: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  stackType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGraphFacilityProductionsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGraphPipelineNetworkThroughputsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGraphPipelineThroughputAssetViewArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGraphPipelineThroughputsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLeadAnalystArgs = {
  countryIsoCode: Scalars['String']['input'];
};


export type QueryLeaseArgs = {
  countryIsoCode: Scalars['String']['input'];
  feature?: InputMaybe<Scalars['String']['input']>;
  legacyId: Scalars['ID']['input'];
};


export type QueryLngLiquefactionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLngProjectArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLngProjectsByNameAndCountryArgs = {
  country?: InputMaybe<Scalars['String']['input']>;
  feature?: InputMaybe<Scalars['String']['input']>;
  search: Scalars['String']['input'];
};


export type QueryLngRegasArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMaAssetsByNameWithFilterArgs = {
  filters?: InputMaybe<MaFilters>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMaDealArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMaDealsArgs = {
  filters?: InputMaybe<MaFilters>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryMaOpportunitiesArgs = {
  filters?: InputMaybe<MaFilters>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryMaOpportunitiesAggregatesArgs = {
  by: MaAggregateByEnum;
  filters?: InputMaybe<MaFilters>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMaOpportunitiesAggregatesStackedArgs = {
  by: MaAggregateByEnum;
  fields: Array<Scalars['String']['input']>;
  filters?: InputMaybe<MaFilters>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  stackBy: MaStackByEnum;
};


export type QueryMaOpportunitiesSummaryArgs = {
  filters?: InputMaybe<MaFilters>;
};


export type QueryMaTransactionsArgs = {
  filters?: InputMaybe<MaFilters>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryMaTransactionsAggregatesArgs = {
  by: MaAggregateByEnum;
  filters?: InputMaybe<MaFilters>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMaTransactionsAggregatesStackedArgs = {
  by: MaAggregateByEnum;
  fields: Array<Scalars['String']['input']>;
  filters?: InputMaybe<MaFilters>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  stackBy: MaStackByEnum;
};


export type QueryMaTransactionsSummaryArgs = {
  filters?: InputMaybe<MaFilters>;
};


export type QueryMapCompaniesArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  layer: Scalars['String']['input'];
  mapType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMapInteractiveCountriesArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  selectedCountry?: InputMaybe<Scalars['JSON']['input']>;
};


export type QueryMapNpvArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  layer: Scalars['String']['input'];
};


export type QueryMapProductionArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  hydrocarbonType?: InputMaybe<Scalars['String']['input']>;
  layer: Scalars['String']['input'];
  mapType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMapReservesArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>;
  hydrocarbonType?: InputMaybe<Scalars['String']['input']>;
  layer: Scalars['String']['input'];
  mapType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMapScreeningArgs = {
  basin?: InputMaybe<Array<Scalars['ID']['input']>>;
  company?: InputMaybe<Array<Scalars['ID']['input']>>;
  country?: InputMaybe<Array<Scalars['ID']['input']>>;
  developmentStatus?: InputMaybe<Array<Scalars['ID']['input']>>;
  hydrocarbonType?: InputMaybe<Array<Scalars['String']['input']>>;
  npvMax?: InputMaybe<Scalars['Float']['input']>;
  npvMin?: InputMaybe<Scalars['Float']['input']>;
  operator?: InputMaybe<Scalars['Boolean']['input']>;
  opportunities?: InputMaybe<Scalars['Boolean']['input']>;
  prodMax?: InputMaybe<Scalars['Float']['input']>;
  prodMin?: InputMaybe<Scalars['Float']['input']>;
  reservesMax?: InputMaybe<Scalars['Float']['input']>;
  reservesMin?: InputMaybe<Scalars['Float']['input']>;
  shoreStatus?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryMapScreeningEaWellsArgs = {
  basinNames?: InputMaybe<Array<Scalars['String']['input']>>;
  companyNames?: InputMaybe<Array<Scalars['String']['input']>>;
  countryIsoCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  hydrocarbonType?: InputMaybe<Array<Scalars['String']['input']>>;
  npvMax?: InputMaybe<Scalars['Float']['input']>;
  npvMin?: InputMaybe<Scalars['Float']['input']>;
  operator?: InputMaybe<Scalars['Boolean']['input']>;
  prodMax?: InputMaybe<Scalars['Float']['input']>;
  prodMin?: InputMaybe<Scalars['Float']['input']>;
  reservesMax?: InputMaybe<Scalars['Float']['input']>;
  reservesMin?: InputMaybe<Scalars['Float']['input']>;
  shoreStatusNames?: InputMaybe<Array<Scalars['String']['input']>>;
  showEaWells?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryNexusJobArgs = {
  jobId: Scalars['String']['input'];
};


export type QueryNexusJobsArgs = {
  areaCode?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  startedBy?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  step?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNexusManualReviewEntitiesArgs = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  entityType?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNexusManualReviewEntityArgs = {
  id: Scalars['ID']['input'];
  levenshteinDistance?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryNexusModelInputsAssetsArgs = {
  assetUuid: Scalars['String']['input'];
  group: Scalars['String']['input'];
};


export type QueryNoopArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryParticipationsArgs = {
  entityId: Scalars['ID']['input'];
  entityType: Scalars['String']['input'];
  grouped?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPipelineArgs = {
  countryIsoCode: Scalars['String']['input'];
  feature?: InputMaybe<Scalars['String']['input']>;
  legacyId: Scalars['ID']['input'];
};


export type QueryPipelineNetworkArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPipelineNetworksByNameAndCountryArgs = {
  country?: InputMaybe<Scalars['ID']['input']>;
  feature?: InputMaybe<Scalars['String']['input']>;
  search: Scalars['String']['input'];
};


export type QueryPipelineSegmentArgs = {
  countryIsoCode: Scalars['String']['input'];
  feature?: InputMaybe<Scalars['String']['input']>;
  legacyId: Scalars['ID']['input'];
};


export type QueryPresaltPolygonArgs = {
  countryIsoCode: Scalars['String']['input'];
  legacyId: Scalars['ID']['input'];
};


export type QueryPublishedCashflowTemplateArgs = {
  countryIsoCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  modelType: Scalars['String']['input'];
};


export type QueryRegionsArgs = {
  feature?: InputMaybe<FeatureEnum>;
};


export type QueryRestrictedAreaArgs = {
  countryIsoCode: Scalars['String']['input'];
  legacyId: Scalars['ID']['input'];
};


export type QuerySecureCcusDownloadArgs = {
  entityType: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type QuerySecureCountryDownloadArgs = {
  countryIsoCode: Scalars['String']['input'];
  downloadType: Scalars['String']['input'];
};


export type QuerySecureRegionDownloadArgs = {
  downloadType: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
  subType?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySecureReportDownloadArgs = {
  assetLegacyId: Scalars['ID']['input'];
  isoCode: Scalars['String']['input'];
  reportType: Scalars['String']['input'];
};


export type QuerySecureSubscriberDownloadArgs = {
  format: SubscriberDownloadReportFormatEnum;
  slug: Scalars['String']['input'];
};


export type QueryShinyUrlArgs = {
  assetName?: InputMaybe<Scalars['String']['input']>;
  iso?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['String']['input'];
};


export type QuerySmartReportArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySmartReportTemplatesArgs = {
  input?: InputMaybe<SmartReportTemplatesInput>;
};


export type QuerySmartReportsListArgs = {
  pagination?: InputMaybe<PaginationInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStorageSiteArgs = {
  id: Scalars['ID']['input'];
  includeDownload?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryUserConfirmationArgs = {
  confirmationToken: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
};


export type QueryUserFiltersArgs = {
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserPortfolioFilterArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserPortfoliosArgs = {
  context: Scalars['String']['input'];
};


export type QueryVideosArgs = {
  after?: InputMaybe<Scalars['Int']['input']>;
  contextPage?: InputMaybe<Array<Scalars['String']['input']>>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  uploadedBy?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type QueryWellArgs = {
  countryIsoCode: Scalars['String']['input'];
  feature?: InputMaybe<Scalars['String']['input']>;
  legacyId: Scalars['ID']['input'];
};


export type QueryWellV2Args = {
  input: EntityIdentifierInput;
};


export type QueryWellsByNameAndCountryArgs = {
  country?: InputMaybe<Scalars['ID']['input']>;
  feature?: InputMaybe<Scalars['String']['input']>;
  search: Scalars['String']['input'];
};

export type Region = {
  __typename?: 'Region';
  coord?: Maybe<Scalars['JSON']['output']>;
  countries?: Maybe<Array<Country>>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isoCode: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  zoom: Scalars['Float']['output'];
};

/** Autogenerated return type of Register. */
export type RegisterPayload = {
  __typename?: 'RegisterPayload';
  /**
   * Authentication credentials. Null if after signUp resource is not active for
   * authentication (e.g. Email confirmation required).
   */
  credentials?: Maybe<Credential>;
  errors?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type RelatedExplorations = {
  __typename?: 'RelatedExplorations';
  assets?: Maybe<Array<Asset>>;
  blocks?: Maybe<Array<Block>>;
};

/** Autogenerated return type of RemoveFromWatchListMutation. */
export type RemoveFromWatchListMutationPayload = {
  __typename?: 'RemoveFromWatchListMutationPayload';
  errors: Array<Scalars['String']['output']>;
  watchList?: Maybe<WatchList>;
};

export type Reserve = {
  __typename?: 'Reserve';
  accumulatedGasBcf?: Maybe<Scalars['Float']['output']>;
  accumulatedLiquidsMmbbl?: Maybe<Scalars['Float']['output']>;
  accumulatedNglMmbbl?: Maybe<Scalars['Float']['output']>;
  accumulatedOilMmbbl?: Maybe<Scalars['Float']['output']>;
  asset: Asset;
  createdAt: Scalars['ISO8601DateTime']['output'];
  formattedGor?: Maybe<Scalars['String']['output']>;
  formattedTotalAccumulatedMmboe?: Maybe<Scalars['String']['output']>;
  formattedTotalRemainingReservesCondensateMmbbl?: Maybe<Scalars['String']['output']>;
  formattedTotalRemainingReservesGasBcf?: Maybe<Scalars['String']['output']>;
  formattedTotalRemainingReservesLiquidsMmbbl?: Maybe<Scalars['String']['output']>;
  formattedTotalRemainingReservesMmboe?: Maybe<Scalars['String']['output']>;
  formattedTotalRemainingReservesOilMmbbl?: Maybe<Scalars['String']['output']>;
  formattedTotalRemainingReservesPercentage?: Maybe<Scalars['String']['output']>;
  formattedTotalReservesGasBcf?: Maybe<Scalars['String']['output']>;
  formattedTotalReservesLiquidMmbbl?: Maybe<Scalars['String']['output']>;
  formattedTotalReservesMmboe?: Maybe<Scalars['String']['output']>;
  gor?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  pctRemainingReserves?: Maybe<Scalars['Float']['output']>;
  pdpCondensateMmbbl?: Maybe<Scalars['Float']['output']>;
  pdpGasBcf?: Maybe<Scalars['Float']['output']>;
  pdpGasMmboe?: Maybe<Scalars['Float']['output']>;
  pdpLiquidsMmbbl?: Maybe<Scalars['Float']['output']>;
  pdpOilMmbbl?: Maybe<Scalars['Float']['output']>;
  totalAccumulatedMmboe?: Maybe<Scalars['Float']['output']>;
  totalRemainingReservesCondensateMmbbl?: Maybe<Scalars['Float']['output']>;
  totalRemainingReservesGasBcf?: Maybe<Scalars['Float']['output']>;
  totalRemainingReservesLiquidsMmbbl?: Maybe<Scalars['Float']['output']>;
  totalRemainingReservesMmboe?: Maybe<Scalars['Float']['output']>;
  totalRemainingReservesOilMmbbl?: Maybe<Scalars['Float']['output']>;
  totalReservesCondensateMmbbl?: Maybe<Scalars['Float']['output']>;
  totalReservesGasBcf?: Maybe<Scalars['Float']['output']>;
  totalReservesLiquidMmbbl?: Maybe<Scalars['Float']['output']>;
  totalReservesMmboe?: Maybe<Scalars['Float']['output']>;
  totalReservesOilMmbbl?: Maybe<Scalars['Float']['output']>;
  undevelopedCondensateMmbbl?: Maybe<Scalars['Float']['output']>;
  undevelopedGasBcf?: Maybe<Scalars['Float']['output']>;
  undevelopedGasMmboe?: Maybe<Scalars['Float']['output']>;
  undevelopedLiquidsMmbbl?: Maybe<Scalars['Float']['output']>;
  undevelopedOilMmbbl?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ResourceTheme = {
  __typename?: 'ResourceTheme';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type ResourceType = {
  __typename?: 'ResourceType';
  createdAt: Scalars['ISO8601DateTime']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type RestrictedArea = {
  __typename?: 'RestrictedArea';
  acreage?: Maybe<Scalars['Float']['output']>;
  country: Country;
  createdAt: Scalars['ISO8601DateTime']['output'];
  fiscalRegime?: Maybe<FiscalRegime>;
  formattedAcreage?: Maybe<Scalars['String']['output']>;
  formattedVerticalDepth?: Maybe<Scalars['String']['output']>;
  formattedVerticalDepthM?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  legacyId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  shoreStatus?: Maybe<ShoreStatus>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  verticalDepthM?: Maybe<Scalars['Float']['output']>;
};

/** Represents the results of a data ingestion tool operation */
export type Results = {
  __typename?: 'Results';
  /** S3 bucket where the results are stored */
  s3Bucket?: Maybe<Scalars['String']['output']>;
  /** S3 file key for the results file */
  s3FileKey?: Maybe<Scalars['String']['output']>;
};

export type SearchFilterItem = {
  __typename?: 'SearchFilterItem';
  checkboxes: Array<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  order: Scalars['Float']['output'];
};

export type SecureDownload = {
  __typename?: 'SecureDownload';
  downloadMessage?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated return type of SeenNewFeatureMutation. */
export type SeenNewFeatureMutationPayload = {
  __typename?: 'SeenNewFeatureMutationPayload';
  errors: Array<Scalars['String']['output']>;
  userWelcome?: Maybe<UserWelcome>;
};

/** Autogenerated return type of SeenUserWelcomeMutation. */
export type SeenUserWelcomeMutationPayload = {
  __typename?: 'SeenUserWelcomeMutationPayload';
  errors: Array<Scalars['String']['output']>;
  userWelcome?: Maybe<UserWelcome>;
};

/** Autogenerated return type of ShareUserFilterMutation. */
export type ShareUserFilterMutationPayload = {
  __typename?: 'ShareUserFilterMutationPayload';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated return type of ShareUserPortfolioMutation. */
export type ShareUserPortfolioMutationPayload = {
  __typename?: 'ShareUserPortfolioMutationPayload';
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type ShoreStatus = {
  __typename?: 'ShoreStatus';
  assetsCount: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Signed URL for uploading a file to S3 */
export type SignedUrl = {
  __typename?: 'SignedUrl';
  /** Fields to include in the upload request */
  fields: Scalars['JSON']['output'];
  /** URL to upload the file to */
  url: Scalars['String']['output'];
};

export type SmartReport = {
  __typename?: 'SmartReport';
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdBy: User;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  smartReportEntities?: Maybe<Array<SmartReportEntity>>;
  smartReportType: SmartReportType;
  smartReportVersions?: Maybe<Array<SmartReportVersion>>;
  status: SmartReportStatusEnum;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Input type for creating a smart report */
export type SmartReportCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  entities?: InputMaybe<Array<SmartReportEntityInput>>;
  name: Scalars['String']['input'];
  templateId?: InputMaybe<Scalars['ID']['input']>;
  typeId: Scalars['ID']['input'];
};

export type SmartReportEntity = {
  __typename?: 'SmartReportEntity';
  entity: Object;
  entityId: Scalars['ID']['output'];
  entityType: SmartReportEntityTypeEnum;
  id: Scalars['ID']['output'];
  smartReportId: Scalars['ID']['output'];
};

export type SmartReportEntityInput = {
  entityId: Scalars['ID']['input'];
  entityType: SmartReportEntityTypeEnum;
};

export enum SmartReportEntityTypeEnum {
  /** Asset entity type */
  Asset = 'Asset',
  /** Company entity type */
  Company = 'Company',
  /** CountryArea entity type */
  CountryArea = 'CountryArea'
}

export type SmartReportPage = {
  __typename?: 'SmartReportPage';
  description?: Maybe<Scalars['String']['output']>;
  layout?: Maybe<Scalars['String']['output']>;
  number: Scalars['Int']['output'];
  pageElements: Array<SmartReportPageElement>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

export type SmartReportPageElement = {
  __typename?: 'SmartReportPageElement';
  componentId: Scalars['String']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  payload?: Maybe<Scalars['JSON']['output']>;
  slotId: Scalars['String']['output'];
  style: Scalars['JSON']['output'];
};

/** Input type for a smart report page element */
export type SmartReportPageElementInput = {
  /** ID of the component */
  componentId?: InputMaybe<Scalars['String']['input']>;
  /** Additional data for the component */
  data?: InputMaybe<Scalars['JSON']['input']>;
  /** Payload data for the component */
  payload?: InputMaybe<Scalars['JSON']['input']>;
  /** ID of the slot for the component in the layout */
  slotId?: InputMaybe<Scalars['String']['input']>;
  /** Style of the component */
  style?: InputMaybe<Scalars['JSON']['input']>;
};

/** Input type for a smart report page */
export type SmartReportPageInput = {
  /** Description of the page */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Layout of the page */
  layout?: InputMaybe<Scalars['String']['input']>;
  /** Page number */
  number: Scalars['Int']['input'];
  /** Elements on the page */
  pageElements: Array<SmartReportPageElementInput>;
  /** URL of the thumbnail image for the page */
  thumbnailUrl?: InputMaybe<Scalars['String']['input']>;
};

export type SmartReportQuery = {
  __typename?: 'SmartReportQuery';
  /** The list of smart reports */
  reports: Array<SmartReport>;
  /** The total count of smart reports */
  totalCount: Scalars['Int']['output'];
};

export enum SmartReportStatusEnum {
  /** archived status */
  Archived = 'ARCHIVED',
  /** draft status */
  Draft = 'DRAFT',
  /** published status */
  Published = 'PUBLISHED'
}

export type SmartReportTemplate = {
  __typename?: 'SmartReportTemplate';
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdBy: User;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  templatePages: Array<SmartReportPage>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Input type for smart report templates query */
export type SmartReportTemplatesInput = {
  /** Sort order (ASC/DESC) */
  order?: InputMaybe<Scalars['String']['input']>;
  /** Field to sort by */
  orderBy?: InputMaybe<Scalars['String']['input']>;
  /** Page number */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Items per page */
  perPage?: InputMaybe<Scalars['Int']['input']>;
};

/** Query type for smart report templates */
export type SmartReportTemplatesQuery = {
  __typename?: 'SmartReportTemplatesQuery';
  /** List of smart report templates */
  templates: Array<SmartReportTemplate>;
  /** Total count of templates */
  totalCount: Scalars['Int']['output'];
};

export type SmartReportType = {
  __typename?: 'SmartReportType';
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type SmartReportUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SmartReportVersion = {
  __typename?: 'SmartReportVersion';
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdBy: User;
  id: Scalars['ID']['output'];
  isLatest: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  pages: Array<SmartReportPage>;
  publishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  publishedBy?: Maybe<User>;
  smartReport: SmartReport;
  status: SmartReportStatusEnum;
  template: SmartReportTemplate;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Input type for updating a smart report version */
export type SmartReportVersionUpdateInput = {
  /** Pages of the smart report version */
  pages: Array<SmartReportPageInput>;
};

/** Represents a source in the data ingestion tool */
export type Source = {
  __typename?: 'Source';
  /** Description of the source */
  description?: Maybe<Scalars['String']['output']>;
  /** Mapping of file tag to list of accepted extensions */
  fileSpecs?: Maybe<Scalars['JSON']['output']>;
  /** Name of the source */
  name: Scalars['String']['output'];
  /** Identifier for the source */
  sourceId: Scalars['String']['output'];
  /** URL of the source if applicable */
  url?: Maybe<Scalars['String']['output']>;
};

/** Represents a source file in the data ingestion tool */
export type SourceFile = {
  __typename?: 'SourceFile';
  /** Name of the source file */
  filename?: Maybe<Scalars['String']['output']>;
  /** S3 bucket where the source file is stored */
  s3Bucket?: Maybe<Scalars['String']['output']>;
  /** S3 file key for the source file */
  s3FileKey?: Maybe<Scalars['String']['output']>;
  /** Tag associated with the source file */
  tag?: Maybe<Scalars['String']['output']>;
};

/** Represents the input structure used when creating a data ingestion event for a source file */
export type SourceFileInput = {
  filename: Scalars['String']['input'];
  tag: Scalars['String']['input'];
};

export enum SubscriberDownloadReportFormatEnum {
  /** HTML format */
  Html = 'html',
  /** PDF format */
  Pdf = 'pdf'
}

/** Autogenerated return type of UpdateMeMutation. */
export type UpdateMeMutationPayload = {
  __typename?: 'UpdateMeMutationPayload';
  errors: Array<Scalars['String']['output']>;
  user?: Maybe<User>;
};

/** Autogenerated return type of UpdateUserFilterMutation. */
export type UpdateUserFilterMutationPayload = {
  __typename?: 'UpdateUserFilterMutationPayload';
  errors: Array<Scalars['String']['output']>;
  userFilter?: Maybe<UserFilter>;
};

export type User = {
  __typename?: 'User';
  admin?: Maybe<Scalars['Boolean']['output']>;
  client?: Maybe<Client>;
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  sharedUserFilters?: Maybe<Array<UserFilter>>;
  sharedUserPortfolios?: Maybe<Array<UserPortfolio>>;
  signInCount?: Maybe<Scalars['Int']['output']>;
  smartReports: Array<SmartReport>;
  userFilters?: Maybe<Array<UserFilter>>;
  userPortfolios?: Maybe<Array<UserPortfolio>>;
  userPriceDecks?: Maybe<Array<UserPriceDeck>>;
};

/** Autogenerated return type of UserConfirmRegistrationWithToken. */
export type UserConfirmRegistrationWithTokenPayload = {
  __typename?: 'UserConfirmRegistrationWithTokenPayload';
  authenticatable: User;
  /** Authentication credentials. Null unless user is signed in after confirmation. */
  credentials?: Maybe<Credential>;
};

export type UserConfirmation = {
  __typename?: 'UserConfirmation';
  confirmed: Scalars['Boolean']['output'];
  redirectUrl?: Maybe<Scalars['String']['output']>;
};

export type UserFilter = {
  __typename?: 'UserFilter';
  filter: Scalars['JSON']['output'];
  filterType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  userId: Scalars['ID']['output'];
};

/** Autogenerated return type of UserLogout. */
export type UserLogoutPayload = {
  __typename?: 'UserLogoutPayload';
  authenticatable: User;
};

export type UserPortfolio = {
  __typename?: 'UserPortfolio';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  portfolio: Scalars['JSON']['output'];
  userId: Scalars['ID']['output'];
};

export type UserPortfolioFilter = {
  __typename?: 'UserPortfolioFilter';
  createdAt: Scalars['ISO8601DateTime']['output'];
  filters: PortfolioFilter;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user: User;
  userId: Scalars['ID']['output'];
  uuid: Scalars['String']['output'];
};

export type UserPriceDeck = {
  __typename?: 'UserPriceDeck';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  priceDeck: Scalars['JSON']['output'];
};

/** Autogenerated return type of UserResendConfirmationWithToken. */
export type UserResendConfirmationWithTokenPayload = {
  __typename?: 'UserResendConfirmationWithTokenPayload';
  message: Scalars['String']['output'];
};

/** Autogenerated return type of UserSendPasswordResetWithToken. */
export type UserSendPasswordResetWithTokenPayload = {
  __typename?: 'UserSendPasswordResetWithTokenPayload';
  message: Scalars['String']['output'];
};

/** Autogenerated return type of UserUpdatePasswordWithToken. */
export type UserUpdatePasswordWithTokenPayload = {
  __typename?: 'UserUpdatePasswordWithTokenPayload';
  authenticatable: User;
  /** Authentication credentials. Resource must be signed_in for credentials to be returned. */
  credentials?: Maybe<Credential>;
};

export type UserWelcome = {
  __typename?: 'UserWelcome';
  features: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  seen: Scalars['Boolean']['output'];
  userId: Scalars['ID']['output'];
};

export type Video = {
  __typename?: 'Video';
  contextOrder: Scalars['Int']['output'];
  contextPage?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  uploadedBy: User;
  url: Scalars['String']['output'];
  views: Scalars['Int']['output'];
};

export type VideoQuery = {
  __typename?: 'VideoQuery';
  totalCount: Scalars['Int']['output'];
  videos: Array<Video>;
};

export type WatchList = {
  __typename?: 'WatchList';
  assetIsoCode: Scalars['String']['output'];
  assetLegacyId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  userId: Scalars['ID']['output'];
};

export type Well = {
  __typename?: 'Well';
  asset?: Maybe<Asset>;
  basin?: Maybe<Basin>;
  block?: Maybe<Block>;
  classificationName?: Maybe<Scalars['String']['output']>;
  cnhDataAvailability?: Maybe<Scalars['String']['output']>;
  country: Country;
  createdAt: Scalars['ISO8601DateTime']['output'];
  depthMeasure?: Maybe<Scalars['Float']['output']>;
  depthVertical?: Maybe<Scalars['Float']['output']>;
  discoveryWell?: Maybe<Scalars['Boolean']['output']>;
  displayName: Scalars['String']['output'];
  drillDays?: Maybe<Scalars['Int']['output']>;
  drilledBy?: Maybe<Scalars['String']['output']>;
  drillingEndDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  drillingRig?: Maybe<Scalars['String']['output']>;
  drillingStartDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  drillingYear?: Maybe<Scalars['Int']['output']>;
  eurGasBcf?: Maybe<Scalars['Float']['output']>;
  eurLiquidsMmbbl?: Maybe<Scalars['Float']['output']>;
  facility?: Maybe<Facility>;
  field?: Maybe<Field>;
  formattedDepthMeasure?: Maybe<Scalars['String']['output']>;
  formattedDepthVertical?: Maybe<Scalars['String']['output']>;
  formattedEurGasBcf?: Maybe<Scalars['String']['output']>;
  formattedEurLiquidsMmbbl?: Maybe<Scalars['String']['output']>;
  formattedFracStageLateralLengthM?: Maybe<Scalars['String']['output']>;
  formattedFracStageSandPumped?: Maybe<Scalars['String']['output']>;
  formattedFracStageWaterInjected?: Maybe<Scalars['String']['output']>;
  formattedGorScfBbl?: Maybe<Scalars['String']['output']>;
  formattedIpGasMmcfd?: Maybe<Scalars['String']['output']>;
  formattedIpLiquidsBbld?: Maybe<Scalars['String']['output']>;
  formattedRecent3MonthWaterCutPct?: Maybe<Scalars['String']['output']>;
  formattedRecentProductionGasMmcfd?: Maybe<Scalars['String']['output']>;
  formattedRecentProductionLiquidsBbld?: Maybe<Scalars['String']['output']>;
  formattedWaterBlade?: Maybe<Scalars['String']['output']>;
  fracStages?: Maybe<Array<FracStage>>;
  geom?: Maybe<Scalars['JSON']['output']>;
  gorScfBbl?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  ipGasMmcfd?: Maybe<Scalars['Float']['output']>;
  ipLiquidsBbld?: Maybe<Scalars['Float']['output']>;
  legacyId: Scalars['ID']['output'];
  mostRecentFracStageCompletionType?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  primaryHydrocarbon?: Maybe<Scalars['String']['output']>;
  prospect?: Maybe<Scalars['String']['output']>;
  recent3MonthWaterCutPct?: Maybe<Scalars['Float']['output']>;
  recentProductionDate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  recentProductionGasMmcfd?: Maybe<Scalars['Float']['output']>;
  recentProductionLiquidsBbld?: Maybe<Scalars['Float']['output']>;
  shoreStatus?: Maybe<ShoreStatus>;
  totalNumFractures?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  uuid: Scalars['ID']['output'];
  waterBlade?: Maybe<Scalars['Int']['output']>;
  weaClassification?: Maybe<Scalars['String']['output']>;
  wellClassification?: Maybe<WellClassification>;
  wellDesign?: Maybe<WellDesign>;
  wellFormation?: Maybe<Scalars['String']['output']>;
  wellResult?: Maybe<Scalars['String']['output']>;
  wellStatus?: Maybe<Scalars['String']['output']>;
};

export type WellClassification = {
  __typename?: 'WellClassification';
  createdAt: Scalars['ISO8601DateTime']['output'];
  displayName: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type WellDesign = {
  __typename?: 'WellDesign';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};
